var items = {
  "block.minecraft.acacia_button": "Akasiuknøttur",
  "block.minecraft.acacia_door": "Akasiuhurð",
  "block.minecraft.acacia_fence": "Akasiugirðing",
  "block.minecraft.acacia_fence_gate": "Akasiugrind",
  "block.minecraft.acacia_hanging_sign": "Hangandi akasiuskelti",
  "block.minecraft.acacia_leaves": "Akasiubløð",
  "block.minecraft.acacia_log": "Akasiustokkur",
  "block.minecraft.acacia_planks": "Akasiuviður",
  "block.minecraft.acacia_pressure_plate": "Akasiutrýstpláta",
  "block.minecraft.acacia_sapling": "Akasiuspíri",
  "block.minecraft.acacia_shelf": "Mimosuhill",
  "block.minecraft.acacia_sign": "Akasiuskelti",
  "block.minecraft.acacia_slab": "Akasiupláta",
  "block.minecraft.acacia_stairs": "Akasiutrappa",
  "block.minecraft.acacia_trapdoor": "Akasiulemmur",
  "block.minecraft.acacia_wall_hanging_sign": "Hangandi akasiuveggskelti",
  "block.minecraft.acacia_wall_sign": "Akasiuveggskelti",
  "block.minecraft.acacia_wood": "Akasiutræ",
  "block.minecraft.activator_rail": "Virkingarskinnari",
  "block.minecraft.air": "Luft",
  "block.minecraft.allium": "Blómuleykur",
  "block.minecraft.amethyst_block": "Ametystkubbi",
  "block.minecraft.amethyst_cluster": "Ametysthópur",
  "block.minecraft.ancient_debris": "Fornleivdir",
  "block.minecraft.andesite": "Andesitt",
  "block.minecraft.andesite_slab": "Andesittpláta",
  "block.minecraft.andesite_stairs": "Andesitttrappa",
  "block.minecraft.andesite_wall": "Andesittveggur",
  "block.minecraft.anvil": "Stiði",
  "block.minecraft.attached_melon_stem": "Festur vatnmelónstelkur",
  "block.minecraft.attached_pumpkin_stem": "Festur graskerjastelkur",
  "block.minecraft.azalea": "Asalea",
  "block.minecraft.azalea_leaves": "Asaleubløð",
  "block.minecraft.azure_bluet": "Blá postalínsblóma",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Bambuskubbi",
  "block.minecraft.bamboo_button": "Bambusknøttur",
  "block.minecraft.bamboo_door": "Bambushurð",
  "block.minecraft.bamboo_fence": "Bambusgirðing",
  "block.minecraft.bamboo_fence_gate": "Bambusgrind",
  "block.minecraft.bamboo_hanging_sign": "Hangandi bambusskelti",
  "block.minecraft.bamboo_mosaic": "Bambusbrot",
  "block.minecraft.bamboo_mosaic_slab": "Bambusbrotapláta",
  "block.minecraft.bamboo_mosaic_stairs": "Bambusbrotatrappa",
  "block.minecraft.bamboo_planks": "Bambusviður",
  "block.minecraft.bamboo_pressure_plate": "Bambustrýstpláta",
  "block.minecraft.bamboo_sapling": "Bambusspíri",
  "block.minecraft.bamboo_shelf": "Bambushill",
  "block.minecraft.bamboo_sign": "Bambusskelti",
  "block.minecraft.bamboo_slab": "Bambuspláta",
  "block.minecraft.bamboo_stairs": "Bambustrappa",
  "block.minecraft.bamboo_trapdoor": "Bamboo Trapdoor",
  "block.minecraft.bamboo_wall_hanging_sign": "Hangandi bambusveggskelti",
  "block.minecraft.bamboo_wall_sign": "Bambusveggskelti",
  "block.minecraft.banner.base.black": "Púra svørt fløta",
  "block.minecraft.banner.base.blue": "Púra blá fløta",
  "block.minecraft.banner.base.brown": "Púra brún fløta",
  "block.minecraft.banner.base.cyan": "Púra blágrøn fløta",
  "block.minecraft.banner.base.gray": "Púra grá fløta",
  "block.minecraft.banner.base.green": "Púra grøn fløta",
  "block.minecraft.banner.base.light_blue": "Púra ljósablá fløta",
  "block.minecraft.banner.base.light_gray": "Púra ljósagrá fløta",
  "block.minecraft.banner.base.lime": "Ljósagrøn fløta",
  "block.minecraft.banner.base.magenta": "Púra viólreyð fløta",
  "block.minecraft.banner.base.orange": "Púra appilsingul fløta",
  "block.minecraft.banner.base.pink": "Púra ljósareyð fløta",
  "block.minecraft.banner.base.purple": "Púra korkareyð fløta",
  "block.minecraft.banner.base.red": "Púra reyð fløta",
  "block.minecraft.banner.base.white": "Púra hvít fløta",
  "block.minecraft.banner.base.yellow": "Púra gul fløta",
  "block.minecraft.banner.border.black": "Svartur bordi",
  "block.minecraft.banner.border.blue": "Bláur bordi",
  "block.minecraft.banner.border.brown": "Brúnur bordi",
  "block.minecraft.banner.border.cyan": "Blágrønur bordi",
  "block.minecraft.banner.border.gray": "Gráur bordi",
  "block.minecraft.banner.border.green": "Grønur bordi",
  "block.minecraft.banner.border.light_blue": "Ljósabláur bordi",
  "block.minecraft.banner.border.light_gray": "Ljósagráur bordi",
  "block.minecraft.banner.border.lime": "Ljósagrønur bordi",
  "block.minecraft.banner.border.magenta": "Viólreyður bordi",
  "block.minecraft.banner.border.orange": "Appilsingulur bordi",
  "block.minecraft.banner.border.pink": "Ljósareyður bordi",
  "block.minecraft.banner.border.purple": "Lilla bordi",
  "block.minecraft.banner.border.red": "Reyður bordi",
  "block.minecraft.banner.border.white": "Hvítur bordi",
  "block.minecraft.banner.border.yellow": "Gulur bordi",
  "block.minecraft.banner.bricks.black": "Svart múrsteinsmynstur",
  "block.minecraft.banner.bricks.blue": "Blátt múrsteinsmynstur",
  "block.minecraft.banner.bricks.brown": "Brúnt múrsteinsmynstur",
  "block.minecraft.banner.bricks.cyan": "Blágrønt múrsteinsmynstur",
  "block.minecraft.banner.bricks.gray": "Grátt múrsteinsmynstur",
  "block.minecraft.banner.bricks.green": "Grønt múrsteinsmynstur",
  "block.minecraft.banner.bricks.light_blue": "Ljósablátt múrsteinsmynstur",
  "block.minecraft.banner.bricks.light_gray": "Ljósagrátt múrsteinsmynstur",
  "block.minecraft.banner.bricks.lime": "Ljósagrønt múrsteinsmynstur",
  "block.minecraft.banner.bricks.magenta": "Viólreytt múrsteinsmynstur",
  "block.minecraft.banner.bricks.orange": "Appilsingult múrsteinsmynstur",
  "block.minecraft.banner.bricks.pink": "Ljósareytt múrsteinsmynstur",
  "block.minecraft.banner.bricks.purple": "Lillað múrsteinsmynstur",
  "block.minecraft.banner.bricks.red": "Reytt múrsteinsmynstur",
  "block.minecraft.banner.bricks.white": "Hvítt múrsteinsmynstur",
  "block.minecraft.banner.bricks.yellow": "Gult múrsteinsmynstur",
  "block.minecraft.banner.circle.black": "Svartur rundingur",
  "block.minecraft.banner.circle.blue": "Bláur rundingur",
  "block.minecraft.banner.circle.brown": "Brúnur rundingur",
  "block.minecraft.banner.circle.cyan": "Blágrønur rundingur",
  "block.minecraft.banner.circle.gray": "Gráur rundingur",
  "block.minecraft.banner.circle.green": "Grønur rundingur",
  "block.minecraft.banner.circle.light_blue": "Ljósabláur rundingur",
  "block.minecraft.banner.circle.light_gray": "Ljósagráur rundingur",
  "block.minecraft.banner.circle.lime": "Ljósagrønur rundingur",
  "block.minecraft.banner.circle.magenta": "Viólreyður rundingur",
  "block.minecraft.banner.circle.orange": "Appilsingulur rundingur",
  "block.minecraft.banner.circle.pink": "Ljósareyður rundingur",
  "block.minecraft.banner.circle.purple": "Lilla rundingur",
  "block.minecraft.banner.circle.red": "Reyður rundingur",
  "block.minecraft.banner.circle.white": "Hvítur rundingur",
  "block.minecraft.banner.circle.yellow": "Gulur rundingur",
  "block.minecraft.banner.creeper.black": "Svartur creeper",
  "block.minecraft.banner.creeper.blue": "Bláur creeper",
  "block.minecraft.banner.creeper.brown": "Brúnur creeper",
  "block.minecraft.banner.creeper.cyan": "Blágrønur creeper",
  "block.minecraft.banner.creeper.gray": "Gráur creeper",
  "block.minecraft.banner.creeper.green": "Grønur creeper",
  "block.minecraft.banner.creeper.light_blue": "Ljósabláur creeper",
  "block.minecraft.banner.creeper.light_gray": "Ljósagráur creeper",
  "block.minecraft.banner.creeper.lime": "Ljósagrønur creeper",
  "block.minecraft.banner.creeper.magenta": "Viólreyður creeper",
  "block.minecraft.banner.creeper.orange": "Appilsingulur creeper",
  "block.minecraft.banner.creeper.pink": "Ljósareyður creeper",
  "block.minecraft.banner.creeper.purple": "Lillaður creeper",
  "block.minecraft.banner.creeper.red": "Reyður creeper",
  "block.minecraft.banner.creeper.white": "Hvítur creeper",
  "block.minecraft.banner.creeper.yellow": "Gulur creeper",
  "block.minecraft.banner.cross.black": "Svartur krossur",
  "block.minecraft.banner.cross.blue": "Bláur krossur",
  "block.minecraft.banner.cross.brown": "Brúnur krossur",
  "block.minecraft.banner.cross.cyan": "Blágrønur krossur",
  "block.minecraft.banner.cross.gray": "Gráur krossur",
  "block.minecraft.banner.cross.green": "Grønur krossur",
  "block.minecraft.banner.cross.light_blue": "Ljósabláur krossur",
  "block.minecraft.banner.cross.light_gray": "Ljósagráur krossur",
  "block.minecraft.banner.cross.lime": "Ljósagrønur krossur",
  "block.minecraft.banner.cross.magenta": "Viólreyður krossur",
  "block.minecraft.banner.cross.orange": "Appilsingulur krossur",
  "block.minecraft.banner.cross.pink": "Ljósareyður krossur",
  "block.minecraft.banner.cross.purple": "Lilla krossur",
  "block.minecraft.banner.cross.red": "Reyður krossur",
  "block.minecraft.banner.cross.white": "Hvítur krossur",
  "block.minecraft.banner.cross.yellow": "Gulur krossur",
  "block.minecraft.banner.curly_border.black": "Svartur bordi við kantum",
  "block.minecraft.banner.curly_border.blue": "Bláur bordi við kantum",
  "block.minecraft.banner.curly_border.brown": "Brúnur bordi við kantum",
  "block.minecraft.banner.curly_border.cyan": "Blágrønur bordi við kantum",
  "block.minecraft.banner.curly_border.gray": "Gráur bordi við kantum",
  "block.minecraft.banner.curly_border.green": "Grønur bordi við kantum",
  "block.minecraft.banner.curly_border.light_blue": "Ljósabláur bordi við kantum",
  "block.minecraft.banner.curly_border.light_gray": "Ljósagráur bordi við kantum",
  "block.minecraft.banner.curly_border.lime": "Ljósagrønur bordi við kantum",
  "block.minecraft.banner.curly_border.magenta": "Viólreyður bordi við kantum",
  "block.minecraft.banner.curly_border.orange": "Appilsingulur bordi við kantum",
  "block.minecraft.banner.curly_border.pink": "Ljósareyður bordi við kantum",
  "block.minecraft.banner.curly_border.purple": "Lilla bordi við kantum",
  "block.minecraft.banner.curly_border.red": "Reyður bordi við kantum",
  "block.minecraft.banner.curly_border.white": "Hvítur bordi við kantum",
  "block.minecraft.banner.curly_border.yellow": "Gulur bordi við kantum",
  "block.minecraft.banner.diagonal_left.black": "Svartur tríkantur uppi til vinstur",
  "block.minecraft.banner.diagonal_left.blue": "Bláur tríkantur uppi til vinstur",
  "block.minecraft.banner.diagonal_left.brown": "Brúnur tríkantur uppi til vinstur",
  "block.minecraft.banner.diagonal_left.cyan": "Blágrønur tríkantur uppi til vinstur",
  "block.minecraft.banner.diagonal_left.gray": "Gráur tríkantur uppi til vinstur",
  "block.minecraft.banner.diagonal_left.green": "Grønur tríkantur uppi til vinstur",
  "block.minecraft.banner.diagonal_left.light_blue": "Ljósabláur tríkantur uppi til vinstur",
  "block.minecraft.banner.diagonal_left.light_gray": "Ljósagráur tríkantur uppi til vinstur",
  "block.minecraft.banner.diagonal_left.lime": "Ljósagrønur tríkantur uppi til vinstri",
  "block.minecraft.banner.diagonal_left.magenta": "Viólreyður tríkantur uppi til vinstur",
  "block.minecraft.banner.diagonal_left.orange": "Appilsingulur tríkantur uppi til vinstur",
  "block.minecraft.banner.diagonal_left.pink": "Ljósareyður tríkantur uppi til vinstur",
  "block.minecraft.banner.diagonal_left.purple": "Lilla tríkantur uppi til vinstur",
  "block.minecraft.banner.diagonal_left.red": "Reyður tríkantur uppi til vinstur",
  "block.minecraft.banner.diagonal_left.white": "Hvítur tríkantur uppi til vinstur",
  "block.minecraft.banner.diagonal_left.yellow": "Gulur tríkantur uppi til vinstur",
  "block.minecraft.banner.diagonal_right.black": "Svartur tríkantur uppi til høgru",
  "block.minecraft.banner.diagonal_right.blue": "Bláur tríkantur uppi til høgru",
  "block.minecraft.banner.diagonal_right.brown": "Brúnur tríkantur uppi til høgru",
  "block.minecraft.banner.diagonal_right.cyan": "Blágrønur tríkantur uppi til høgru",
  "block.minecraft.banner.diagonal_right.gray": "Gráur tríkantur uppi til høgru",
  "block.minecraft.banner.diagonal_right.green": "Grønur tríkantur uppi til høgru",
  "block.minecraft.banner.diagonal_right.light_blue": "Ljósabláur tríkantur uppi til høgru",
  "block.minecraft.banner.diagonal_right.light_gray": "Ljósagráur tríkantur uppi til høgru",
  "block.minecraft.banner.diagonal_right.lime": "Ljósagrønur tríkantur uppi til høgri",
  "block.minecraft.banner.diagonal_right.magenta": "Viólreyður tríkantur uppi til høgru",
  "block.minecraft.banner.diagonal_right.orange": "Appilsingulur tríkantur uppi til høgru",
  "block.minecraft.banner.diagonal_right.pink": "Ljósareyður tríkantur uppi til høgru",
  "block.minecraft.banner.diagonal_right.purple": "Lilla tríkantur uppi til høgru",
  "block.minecraft.banner.diagonal_right.red": "Reyður tríkantur uppi til høgru",
  "block.minecraft.banner.diagonal_right.white": "Hvítur tríkantur uppi til høgru",
  "block.minecraft.banner.diagonal_right.yellow": "Gulur tríkantur uppi til høgru",
  "block.minecraft.banner.diagonal_up_left.black": "Svartur tríkantur niðri til vinstru",
  "block.minecraft.banner.diagonal_up_left.blue": "Bláur tríkantur niðri til vinstru",
  "block.minecraft.banner.diagonal_up_left.brown": "Brúnur tríkantur niðri til vinstru",
  "block.minecraft.banner.diagonal_up_left.cyan": "Blágrønur tríkantur niðri til vinstru",
  "block.minecraft.banner.diagonal_up_left.gray": "Gráur tríkantur niðri til vinstru",
  "block.minecraft.banner.diagonal_up_left.green": "Grønur tríkantur niðri til vinstru",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Ljósabláur tríkantur niðri til vinstru",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Ljósagráur tríkantur niðri til vinstru",
  "block.minecraft.banner.diagonal_up_left.lime": "Ljósagrønur tríkantur niðri til vinstri",
  "block.minecraft.banner.diagonal_up_left.magenta": "Viólreyður tríkantur niðri til vinstru",
  "block.minecraft.banner.diagonal_up_left.orange": "Appilsingulur tríkantur niðri til vinstru",
  "block.minecraft.banner.diagonal_up_left.pink": "Ljósareyður tríkantur niðri til vinstru",
  "block.minecraft.banner.diagonal_up_left.purple": "Lilla tríkantur niðri til vinstru",
  "block.minecraft.banner.diagonal_up_left.red": "Reyður tríkantur niðri til vinstru",
  "block.minecraft.banner.diagonal_up_left.white": "Hvítur tríkantur niðri til vinstru",
  "block.minecraft.banner.diagonal_up_left.yellow": "Gulur tríkantur niðri til vinstru",
  "block.minecraft.banner.diagonal_up_right.black": "Svartur tríkantur niðri til høgru",
  "block.minecraft.banner.diagonal_up_right.blue": "Bláur tríkantur niðri til høgru",
  "block.minecraft.banner.diagonal_up_right.brown": "Brúnur tríkantur niðri til høgru",
  "block.minecraft.banner.diagonal_up_right.cyan": "Blágrønur tríkantur niðri til høgru",
  "block.minecraft.banner.diagonal_up_right.gray": "Gráur tríkantur niðri til høgru",
  "block.minecraft.banner.diagonal_up_right.green": "Grønur tríkantur niðri til høgru",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Ljósabláur tríkantur niðri til høgru",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Ljósagráur tríkantur niðri til høgru",
  "block.minecraft.banner.diagonal_up_right.lime": "Ljósagrønur tríkantur niðri til høgri",
  "block.minecraft.banner.diagonal_up_right.magenta": "Viólreyður tríkantur niðri til høgru",
  "block.minecraft.banner.diagonal_up_right.orange": "Appilsingulur tríkantur niðri til høgru",
  "block.minecraft.banner.diagonal_up_right.pink": "Ljósareyður tríkantur niðri til høgru",
  "block.minecraft.banner.diagonal_up_right.purple": "Lilla tríkantur niðri til høgru",
  "block.minecraft.banner.diagonal_up_right.red": "Reyður tríkantur niðri til høgru",
  "block.minecraft.banner.diagonal_up_right.white": "Hvítur tríkantur niðri til høgru",
  "block.minecraft.banner.diagonal_up_right.yellow": "Gulur tríkantur niðri til høgru",
  "block.minecraft.banner.flow.black": "Svørt flóð",
  "block.minecraft.banner.flow.blue": "Blá flóð",
  "block.minecraft.banner.flow.brown": "Brún flóð",
  "block.minecraft.banner.flow.cyan": "Blágrøn flóð",
  "block.minecraft.banner.flow.gray": "Grá flóð",
  "block.minecraft.banner.flow.green": "Grøn flóð",
  "block.minecraft.banner.flow.light_blue": "Ljósablá flóð",
  "block.minecraft.banner.flow.light_gray": "Ljósagrá flóð",
  "block.minecraft.banner.flow.lime": "Ljósagrøn flóð",
  "block.minecraft.banner.flow.magenta": "Viólreyð flóð",
  "block.minecraft.banner.flow.orange": "Appilsingul flóð",
  "block.minecraft.banner.flow.pink": "Ljósareyð flóð",
  "block.minecraft.banner.flow.purple": "Korkareyð flóð",
  "block.minecraft.banner.flow.red": "Reyð flóð",
  "block.minecraft.banner.flow.white": "Hvít flóð",
  "block.minecraft.banner.flow.yellow": "Gul flóð",
  "block.minecraft.banner.flower.black": "Svørt blóma",
  "block.minecraft.banner.flower.blue": "Blá blóma",
  "block.minecraft.banner.flower.brown": "Brún blóma",
  "block.minecraft.banner.flower.cyan": "Blágrøn blóma",
  "block.minecraft.banner.flower.gray": "Grá blóma",
  "block.minecraft.banner.flower.green": "Grøn blóma",
  "block.minecraft.banner.flower.light_blue": "Ljósablá blóma",
  "block.minecraft.banner.flower.light_gray": "Ljósagrá blóma",
  "block.minecraft.banner.flower.lime": "Ljósagrøn blóma",
  "block.minecraft.banner.flower.magenta": "Viólreyð blóma",
  "block.minecraft.banner.flower.orange": "Appilsingul blóma",
  "block.minecraft.banner.flower.pink": "Ljósareyð blóma",
  "block.minecraft.banner.flower.purple": "Lilla blóma",
  "block.minecraft.banner.flower.red": "Reyð blóma",
  "block.minecraft.banner.flower.white": "Hvít blóma",
  "block.minecraft.banner.flower.yellow": "Gul blóma",
  "block.minecraft.banner.globe.black": "Svørt globus",
  "block.minecraft.banner.globe.blue": "Blá globus",
  "block.minecraft.banner.globe.brown": "Brún globus",
  "block.minecraft.banner.globe.cyan": "Blágrøn globus",
  "block.minecraft.banner.globe.gray": "Grá globus",
  "block.minecraft.banner.globe.green": "Grøn globus",
  "block.minecraft.banner.globe.light_blue": "Ljósablá globus",
  "block.minecraft.banner.globe.light_gray": "Ljósagrá globus",
  "block.minecraft.banner.globe.lime": "Ljósagrønur knøttur",
  "block.minecraft.banner.globe.magenta": "Viólreyð globus",
  "block.minecraft.banner.globe.orange": "Appilsingul globus",
  "block.minecraft.banner.globe.pink": "Ljósareyð globus",
  "block.minecraft.banner.globe.purple": "Lillað globus",
  "block.minecraft.banner.globe.red": "Reyð globus",
  "block.minecraft.banner.globe.white": "Hvít globus",
  "block.minecraft.banner.globe.yellow": "Gul globus",
  "block.minecraft.banner.gradient.black": "Svatur hallvinkul",
  "block.minecraft.banner.gradient.blue": "Bláur hallvinkul",
  "block.minecraft.banner.gradient.brown": "Brúnur hallvinkul",
  "block.minecraft.banner.gradient.cyan": "Blágrønur hallvinkul",
  "block.minecraft.banner.gradient.gray": "Gráur hallvinkul",
  "block.minecraft.banner.gradient.green": "Grønur hallvinkul",
  "block.minecraft.banner.gradient.light_blue": "Ljósabláur hallvinkul",
  "block.minecraft.banner.gradient.light_gray": "Ljósagráur hallvinkul",
  "block.minecraft.banner.gradient.lime": "Ljósagrønur hallvinkul",
  "block.minecraft.banner.gradient.magenta": "Viólreyður hallvinkul",
  "block.minecraft.banner.gradient.orange": "Appilsingulur hallvinkul",
  "block.minecraft.banner.gradient.pink": "Ljósareyður hallvinkul",
  "block.minecraft.banner.gradient.purple": "Lilla hallvinkul",
  "block.minecraft.banner.gradient.red": "Reyður hallvinkul",
  "block.minecraft.banner.gradient.white": "Hvítur hallvinkul",
  "block.minecraft.banner.gradient.yellow": "Gulur hallvinkul",
  "block.minecraft.banner.gradient_up.black": "Svartur hallvinkul niðanífrá",
  "block.minecraft.banner.gradient_up.blue": "Bláur hallvinkul niðanífrá",
  "block.minecraft.banner.gradient_up.brown": "Brúnur hallvinkul niðanífrá",
  "block.minecraft.banner.gradient_up.cyan": "Blágrønur hallvinkul niðanífrá",
  "block.minecraft.banner.gradient_up.gray": "Gráur hallvinkul niðanífrá",
  "block.minecraft.banner.gradient_up.green": "Grønur hallvinkul niðanífrá",
  "block.minecraft.banner.gradient_up.light_blue": "Ljósabláur hallvinkul niðanífrá",
  "block.minecraft.banner.gradient_up.light_gray": "Ljósagráur hallvinkul niðanífrá",
  "block.minecraft.banner.gradient_up.lime": "Ljósagrønur hallvinkul niðanifrá",
  "block.minecraft.banner.gradient_up.magenta": "Viólreyður hallvinkul niðanífrá",
  "block.minecraft.banner.gradient_up.orange": "Appilsingulur hallvinkul niðanífrá",
  "block.minecraft.banner.gradient_up.pink": "Ljósareyður hallvinkul niðanífrá",
  "block.minecraft.banner.gradient_up.purple": "Lilla hallvinkul niðanífrá",
  "block.minecraft.banner.gradient_up.red": "Reyður hallvinkul niðanífrá",
  "block.minecraft.banner.gradient_up.white": "Hvítur hallvinkul niðanífrá",
  "block.minecraft.banner.gradient_up.yellow": "Gulur hallvinkul niðanífrá",
  "block.minecraft.banner.guster.black": "Svartur gjóstur",
  "block.minecraft.banner.guster.blue": "Bláur gjóstur",
  "block.minecraft.banner.guster.brown": "Brúnur gjóstur",
  "block.minecraft.banner.guster.cyan": "Blágrønur gjóstur",
  "block.minecraft.banner.guster.gray": "Gráur gjóstur",
  "block.minecraft.banner.guster.green": "Grønur gjóstur",
  "block.minecraft.banner.guster.light_blue": "Ljósabláur gjóstur",
  "block.minecraft.banner.guster.light_gray": "Ljósagráur gjóstur",
  "block.minecraft.banner.guster.lime": "Ljósagrønur gjóstur",
  "block.minecraft.banner.guster.magenta": "Viólreyður gjóstur",
  "block.minecraft.banner.guster.orange": "Appilsingulur gjóstur",
  "block.minecraft.banner.guster.pink": "Ljósareyður gjóstur",
  "block.minecraft.banner.guster.purple": "Korkareyður gjóstur",
  "block.minecraft.banner.guster.red": "Reyður gjóstur",
  "block.minecraft.banner.guster.white": "Hvítur gjóstur",
  "block.minecraft.banner.guster.yellow": "Gulur gjóstur",
  "block.minecraft.banner.half_horizontal.black": "Svartur ovaripartur",
  "block.minecraft.banner.half_horizontal.blue": "Bláur ovaripartur",
  "block.minecraft.banner.half_horizontal.brown": "Brúnur ovaripartur",
  "block.minecraft.banner.half_horizontal.cyan": "Blágrønur ovaripartur",
  "block.minecraft.banner.half_horizontal.gray": "Gráur ovaripartur",
  "block.minecraft.banner.half_horizontal.green": "Grønur ovaripartur",
  "block.minecraft.banner.half_horizontal.light_blue": "Ljósabláur ovaripartur",
  "block.minecraft.banner.half_horizontal.light_gray": "Ljósagráur ovaripartur",
  "block.minecraft.banner.half_horizontal.lime": "Ljósagrønur ovaripartur",
  "block.minecraft.banner.half_horizontal.magenta": "Viólreyður ovaripartur",
  "block.minecraft.banner.half_horizontal.orange": "Appilsingulur ovaripartur",
  "block.minecraft.banner.half_horizontal.pink": "Ljósareyður ovaripartur",
  "block.minecraft.banner.half_horizontal.purple": "Lilla ovaripartur",
  "block.minecraft.banner.half_horizontal.red": "Reyður ovaripartur",
  "block.minecraft.banner.half_horizontal.white": "Hvítur ovaripartur",
  "block.minecraft.banner.half_horizontal.yellow": "Gulur ovaripartur",
  "block.minecraft.banner.half_horizontal_bottom.black": "Svartur niðaripartur",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Bláur niðaripartur",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Brúnur niðaripartur",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Blágrønur niðaripartur",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Gráur niðaripartur",
  "block.minecraft.banner.half_horizontal_bottom.green": "Grønur niðaripartur",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Ljósabláur niðaripartur",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Ljósagráur niðaripartur",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Ljósagrønur niðaripartur",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Viólreyður niðaripartur",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Appilsingulur niðaripartur",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Ljósareyður niðaripartur",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Lilla niðaripartur",
  "block.minecraft.banner.half_horizontal_bottom.red": "Reyður niðaripartur",
  "block.minecraft.banner.half_horizontal_bottom.white": "Hvítur niðaripartur",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Gulur niðaripartur",
  "block.minecraft.banner.half_vertical.black": "Svørt vinstrisíða",
  "block.minecraft.banner.half_vertical.blue": "Blá vinstrisíða",
  "block.minecraft.banner.half_vertical.brown": "Brún vinstrisíða",
  "block.minecraft.banner.half_vertical.cyan": "Blágrøn vinstrisíða",
  "block.minecraft.banner.half_vertical.gray": "Grá vinstrisíða",
  "block.minecraft.banner.half_vertical.green": "Grøn vinstrisíða",
  "block.minecraft.banner.half_vertical.light_blue": "Ljósablá vinstrisíða",
  "block.minecraft.banner.half_vertical.light_gray": "Ljósagrá vinstrisíða",
  "block.minecraft.banner.half_vertical.lime": "Ljósagrøn vinstrisíða",
  "block.minecraft.banner.half_vertical.magenta": "Viólreyð vinstrisíða",
  "block.minecraft.banner.half_vertical.orange": "Appilsingul vinstrisíða",
  "block.minecraft.banner.half_vertical.pink": "Ljósareyð vinstrisíða",
  "block.minecraft.banner.half_vertical.purple": "Lilla vinstrisíða",
  "block.minecraft.banner.half_vertical.red": "Reyð vinstrisíða",
  "block.minecraft.banner.half_vertical.white": "Hvít vinstrisíða",
  "block.minecraft.banner.half_vertical.yellow": "Gul vinstrisíða",
  "block.minecraft.banner.half_vertical_right.black": "Svørt høgrisíða",
  "block.minecraft.banner.half_vertical_right.blue": "Blá høgrisíða",
  "block.minecraft.banner.half_vertical_right.brown": "Brún høgrisíða",
  "block.minecraft.banner.half_vertical_right.cyan": "Blágrøn høgrisíða",
  "block.minecraft.banner.half_vertical_right.gray": "Grá høgrisíða",
  "block.minecraft.banner.half_vertical_right.green": "Grøn høgrisíða",
  "block.minecraft.banner.half_vertical_right.light_blue": "Ljósablá høgrisíða",
  "block.minecraft.banner.half_vertical_right.light_gray": "Ljósagrá høgrisíða",
  "block.minecraft.banner.half_vertical_right.lime": "Ljósagrøn høgrisíða",
  "block.minecraft.banner.half_vertical_right.magenta": "Viólreyð høgrisíða",
  "block.minecraft.banner.half_vertical_right.orange": "Appilsingul høgrisíða",
  "block.minecraft.banner.half_vertical_right.pink": "Ljósareyð høgrisíða",
  "block.minecraft.banner.half_vertical_right.purple": "Lilla høgrisíða",
  "block.minecraft.banner.half_vertical_right.red": "Reyð høgrisíða",
  "block.minecraft.banner.half_vertical_right.white": "Hvít høgrisíða",
  "block.minecraft.banner.half_vertical_right.yellow": "Gul høgrisíða",
  "block.minecraft.banner.mojang.black": "Svartur lutur",
  "block.minecraft.banner.mojang.blue": "Bláur lutur",
  "block.minecraft.banner.mojang.brown": "Brúnur lutur",
  "block.minecraft.banner.mojang.cyan": "Blágrønur lutur",
  "block.minecraft.banner.mojang.gray": "Gráur lutur",
  "block.minecraft.banner.mojang.green": "Grønur lutur",
  "block.minecraft.banner.mojang.light_blue": "Ljósabláur lutur",
  "block.minecraft.banner.mojang.light_gray": "Ljósagráur lutur",
  "block.minecraft.banner.mojang.lime": "Ljósagrønur lutur",
  "block.minecraft.banner.mojang.magenta": "Viólreyður lutur",
  "block.minecraft.banner.mojang.orange": "Appilsingulur lutur",
  "block.minecraft.banner.mojang.pink": "Ljósareyður lutur",
  "block.minecraft.banner.mojang.purple": "Lilla lutur",
  "block.minecraft.banner.mojang.red": "Reyður lutur",
  "block.minecraft.banner.mojang.white": "Hvítur lutur",
  "block.minecraft.banner.mojang.yellow": "Gulur lutur",
  "block.minecraft.banner.piglin.black": "Svartur snúti",
  "block.minecraft.banner.piglin.blue": "Bláur snúti",
  "block.minecraft.banner.piglin.brown": "Brúnur snúti",
  "block.minecraft.banner.piglin.cyan": "Blágrønur snúti",
  "block.minecraft.banner.piglin.gray": "Gráur snúti",
  "block.minecraft.banner.piglin.green": "Grønur snúti",
  "block.minecraft.banner.piglin.light_blue": "Ljósablaúr snúti",
  "block.minecraft.banner.piglin.light_gray": "Ljósagráur snúti",
  "block.minecraft.banner.piglin.lime": "Ljósagrønur snúti",
  "block.minecraft.banner.piglin.magenta": "Violreyður snúti",
  "block.minecraft.banner.piglin.orange": "Appilsingulur snúti",
  "block.minecraft.banner.piglin.pink": "Ljósareyður snúti",
  "block.minecraft.banner.piglin.purple": "Lillaður snúti",
  "block.minecraft.banner.piglin.red": "Reyður snúti",
  "block.minecraft.banner.piglin.white": "Hvítur snúti",
  "block.minecraft.banner.piglin.yellow": "Gulur snúti",
  "block.minecraft.banner.rhombus.black": "Svørt romba",
  "block.minecraft.banner.rhombus.blue": "Blá romba",
  "block.minecraft.banner.rhombus.brown": "Brún romba",
  "block.minecraft.banner.rhombus.cyan": "Blágrøn romba",
  "block.minecraft.banner.rhombus.gray": "Grá romba",
  "block.minecraft.banner.rhombus.green": "Grøn romba",
  "block.minecraft.banner.rhombus.light_blue": "Ljósablá romba",
  "block.minecraft.banner.rhombus.light_gray": "Ljósagrá romba",
  "block.minecraft.banner.rhombus.lime": "Ljósagrøn romba",
  "block.minecraft.banner.rhombus.magenta": "Viólreyð romba",
  "block.minecraft.banner.rhombus.orange": "Appilsingul romba",
  "block.minecraft.banner.rhombus.pink": "Ljósareyð romba",
  "block.minecraft.banner.rhombus.purple": "Lilla romba",
  "block.minecraft.banner.rhombus.red": "Reyð romba",
  "block.minecraft.banner.rhombus.white": "Hvít romba",
  "block.minecraft.banner.rhombus.yellow": "Gul romba",
  "block.minecraft.banner.skull.black": "Svørt beinagrind",
  "block.minecraft.banner.skull.blue": "Blá beinagrind",
  "block.minecraft.banner.skull.brown": "Brún beinagrind",
  "block.minecraft.banner.skull.cyan": "Blágrøn beinagrind",
  "block.minecraft.banner.skull.gray": "Grá beinagrind",
  "block.minecraft.banner.skull.green": "Grøn beinagrind",
  "block.minecraft.banner.skull.light_blue": "Ljósablá beinagrind",
  "block.minecraft.banner.skull.light_gray": "Ljósagrá beinagrind",
  "block.minecraft.banner.skull.lime": "Ljósagrøn beinagrind",
  "block.minecraft.banner.skull.magenta": "Viólreyð beinagrind",
  "block.minecraft.banner.skull.orange": "Appilsingul beinagrind",
  "block.minecraft.banner.skull.pink": "Ljósareyð beinagrind",
  "block.minecraft.banner.skull.purple": "Lilla beinagrind",
  "block.minecraft.banner.skull.red": "Reyð beinagrind",
  "block.minecraft.banner.skull.white": "Hvít beinagrind",
  "block.minecraft.banner.skull.yellow": "Gul beinagrind",
  "block.minecraft.banner.small_stripes.black": "Svartar grindir",
  "block.minecraft.banner.small_stripes.blue": "Bláar grindir",
  "block.minecraft.banner.small_stripes.brown": "Brúnar grindir",
  "block.minecraft.banner.small_stripes.cyan": "Blágrønar grindir",
  "block.minecraft.banner.small_stripes.gray": "Gráar grindir",
  "block.minecraft.banner.small_stripes.green": "Grønar grindir",
  "block.minecraft.banner.small_stripes.light_blue": "Ljósabláar grindir",
  "block.minecraft.banner.small_stripes.light_gray": "Ljósagráar grindir",
  "block.minecraft.banner.small_stripes.lime": "Ljósagrønar grindir",
  "block.minecraft.banner.small_stripes.magenta": "Viólreyðar grindir",
  "block.minecraft.banner.small_stripes.orange": "Appilsingular grindir",
  "block.minecraft.banner.small_stripes.pink": "Ljósareyðar grindir",
  "block.minecraft.banner.small_stripes.purple": "Lilla grindir",
  "block.minecraft.banner.small_stripes.red": "Reyðar grindir",
  "block.minecraft.banner.small_stripes.white": "Hvítar grindir",
  "block.minecraft.banner.small_stripes.yellow": "Gular grindir",
  "block.minecraft.banner.square_bottom_left.black": "Svartur fýrakantur niðast til vinstru",
  "block.minecraft.banner.square_bottom_left.blue": "Bláur fýrakantur niðast til vinstru",
  "block.minecraft.banner.square_bottom_left.brown": "Brúnur fýrakantur niðast til vinstru",
  "block.minecraft.banner.square_bottom_left.cyan": "Blágrønur fýrakantur niðast til vinstru",
  "block.minecraft.banner.square_bottom_left.gray": "Gráur fýrakantur niðast til vinstru",
  "block.minecraft.banner.square_bottom_left.green": "Grønur fýrakantur niðast til vinstru",
  "block.minecraft.banner.square_bottom_left.light_blue": "Ljósagráur fýrakantur niðast til vinstru",
  "block.minecraft.banner.square_bottom_left.light_gray": "Ljósagráur fýrakantur niðast til vinstru",
  "block.minecraft.banner.square_bottom_left.lime": "Ljósagrønur fýrakantur niðast til vinstri",
  "block.minecraft.banner.square_bottom_left.magenta": "Viólreyður fýrakantur niðast til vinstru",
  "block.minecraft.banner.square_bottom_left.orange": "Appilsingulur fýrakantur niðast til vinstru",
  "block.minecraft.banner.square_bottom_left.pink": "Ljósareyður fýrakantur niðast til vinstru",
  "block.minecraft.banner.square_bottom_left.purple": "Lilla fýrakantur niðast til vinstru",
  "block.minecraft.banner.square_bottom_left.red": "Reyður fýrakantur niðast til vinstru",
  "block.minecraft.banner.square_bottom_left.white": "Hvítur fýrakantur niðast til vinstru",
  "block.minecraft.banner.square_bottom_left.yellow": "Gulur fýrakantur niðast til vinstru",
  "block.minecraft.banner.square_bottom_right.black": "Svartur fýrakantur niðast til høgru",
  "block.minecraft.banner.square_bottom_right.blue": "Bláur fýrakantur niðast til høgru",
  "block.minecraft.banner.square_bottom_right.brown": "Brúnur fýrakantur niðast til høgru",
  "block.minecraft.banner.square_bottom_right.cyan": "Blágrønur fýrakantur niðast til høgru",
  "block.minecraft.banner.square_bottom_right.gray": "Gráur fýrakantur niðast til høgru",
  "block.minecraft.banner.square_bottom_right.green": "Grønur fýrakantur niðast til høgru",
  "block.minecraft.banner.square_bottom_right.light_blue": "Ljósabláur fýrakantur niðast til høgru",
  "block.minecraft.banner.square_bottom_right.light_gray": "Ljósagráur fýrakantur niðast til høgru",
  "block.minecraft.banner.square_bottom_right.lime": "Ljósagrønur fýrakantur niðast til høgri",
  "block.minecraft.banner.square_bottom_right.magenta": "Viólreyður fýrakantur niðast til høgru",
  "block.minecraft.banner.square_bottom_right.orange": "Appilsingulur fýrakantur niðast til høgru",
  "block.minecraft.banner.square_bottom_right.pink": "Ljósareyður fýrakantur niðast til høgru",
  "block.minecraft.banner.square_bottom_right.purple": "Lilla fýrakantur niðast til høgru",
  "block.minecraft.banner.square_bottom_right.red": "Reyður fýrakantur niðast til høgru",
  "block.minecraft.banner.square_bottom_right.white": "Hvítur fýrakantur niðast til høgru",
  "block.minecraft.banner.square_bottom_right.yellow": "Gulur fýrakantur niðast til høgru",
  "block.minecraft.banner.square_top_left.black": "Svartur fýrakantur uppi til vinstru",
  "block.minecraft.banner.square_top_left.blue": "Bláur fýrakantur uppi til vinstru",
  "block.minecraft.banner.square_top_left.brown": "Brúnur fýrakantur uppi til vinstru",
  "block.minecraft.banner.square_top_left.cyan": "Blágrønu fýrakantur uppi til vinstru",
  "block.minecraft.banner.square_top_left.gray": "Gráur fýrakantur uppi til vinstru",
  "block.minecraft.banner.square_top_left.green": "Grønur fýrakantur uppi til vinstru",
  "block.minecraft.banner.square_top_left.light_blue": "Ljósabláur fýrakantur uppi til vinstru",
  "block.minecraft.banner.square_top_left.light_gray": "Ljósagráur fýrakantur uppi til vinstru",
  "block.minecraft.banner.square_top_left.lime": "Ljósagrønur fýrakantur uppi til vinstri",
  "block.minecraft.banner.square_top_left.magenta": "Viólreyður fýrakantur uppi til vinstru",
  "block.minecraft.banner.square_top_left.orange": "Appilsingulur fýrakantur uppi til vinstru",
  "block.minecraft.banner.square_top_left.pink": "Ljósareyður fýrakantur uppi til vinstru",
  "block.minecraft.banner.square_top_left.purple": "Lilla fýrakantur uppi til vinstru",
  "block.minecraft.banner.square_top_left.red": "Reyður fýrakantur uppi til vinstru",
  "block.minecraft.banner.square_top_left.white": "Hvítur fýrakantur uppi til vinstru",
  "block.minecraft.banner.square_top_left.yellow": "Gulur fýrakantur uppi til vinstru",
  "block.minecraft.banner.square_top_right.black": "Svartur fýrakantur uppi til høgru",
  "block.minecraft.banner.square_top_right.blue": "Bláur fýrakantur uppi til høgru",
  "block.minecraft.banner.square_top_right.brown": "Brúnur fýrakantur uppi til høgru",
  "block.minecraft.banner.square_top_right.cyan": "Blágrønur fýrakantur uppi til høgru",
  "block.minecraft.banner.square_top_right.gray": "Gráur fýrakantur uppi til høgru",
  "block.minecraft.banner.square_top_right.green": "Grønur fýrakantur uppi til høgru",
  "block.minecraft.banner.square_top_right.light_blue": "Ljósabláur fýrakantur uppi til høgru",
  "block.minecraft.banner.square_top_right.light_gray": "Ljósagráur fýrakantur uppi til høgru",
  "block.minecraft.banner.square_top_right.lime": "Ljósagrønur fýrakantur uppi til høgri",
  "block.minecraft.banner.square_top_right.magenta": "Viólreyður fýrakantur uppi til høgru",
  "block.minecraft.banner.square_top_right.orange": "Appilsingulur fýrakantur uppi til høgru",
  "block.minecraft.banner.square_top_right.pink": "Ljósareyður fýrakantur uppi til høgru",
  "block.minecraft.banner.square_top_right.purple": "Lilla fýrakantur uppi til høgru",
  "block.minecraft.banner.square_top_right.red": "Reyður fýrakantur uppi til høgru",
  "block.minecraft.banner.square_top_right.white": "Hvítur fýrakantur uppi til høgru",
  "block.minecraft.banner.square_top_right.yellow": "Gulur fýrakantur uppi til høgru",
  "block.minecraft.banner.straight_cross.black": "Svartur krossur",
  "block.minecraft.banner.straight_cross.blue": "Bláur krossur",
  "block.minecraft.banner.straight_cross.brown": "Brúnur krossur",
  "block.minecraft.banner.straight_cross.cyan": "Blágrønur krossur",
  "block.minecraft.banner.straight_cross.gray": "Gráur krossur",
  "block.minecraft.banner.straight_cross.green": "Grønur krossur",
  "block.minecraft.banner.straight_cross.light_blue": "Ljósabláur krossur",
  "block.minecraft.banner.straight_cross.light_gray": "Ljósagráur krossur",
  "block.minecraft.banner.straight_cross.lime": "Ljósagrønur krossur",
  "block.minecraft.banner.straight_cross.magenta": "Viólreyður krossur",
  "block.minecraft.banner.straight_cross.orange": "Appilsingulur krossur",
  "block.minecraft.banner.straight_cross.pink": "Ljósareyður krossur",
  "block.minecraft.banner.straight_cross.purple": "Lilla krossur",
  "block.minecraft.banner.straight_cross.red": "Reyður krossur",
  "block.minecraft.banner.straight_cross.white": "Hvítur krossur",
  "block.minecraft.banner.straight_cross.yellow": "Gulur krossur",
  "block.minecraft.banner.stripe_bottom.black": "Svørt grund",
  "block.minecraft.banner.stripe_bottom.blue": "Blá grund",
  "block.minecraft.banner.stripe_bottom.brown": "Brún grund",
  "block.minecraft.banner.stripe_bottom.cyan": "Blágrøn grund",
  "block.minecraft.banner.stripe_bottom.gray": "Grá grund",
  "block.minecraft.banner.stripe_bottom.green": "Grøn grund",
  "block.minecraft.banner.stripe_bottom.light_blue": "Ljósablá grund",
  "block.minecraft.banner.stripe_bottom.light_gray": "Ljósagrá grund",
  "block.minecraft.banner.stripe_bottom.lime": "Ljósagrøn grund",
  "block.minecraft.banner.stripe_bottom.magenta": "Viólreyð grund",
  "block.minecraft.banner.stripe_bottom.orange": "Appilsingul grund",
  "block.minecraft.banner.stripe_bottom.pink": "Ljósareyð grund",
  "block.minecraft.banner.stripe_bottom.purple": "Lilla grund",
  "block.minecraft.banner.stripe_bottom.red": "Reyð grund",
  "block.minecraft.banner.stripe_bottom.white": "Hvít grund",
  "block.minecraft.banner.stripe_bottom.yellow": "Gul grund",
  "block.minecraft.banner.stripe_center.black": "Svart loddrætt í miðjuni",
  "block.minecraft.banner.stripe_center.blue": "Blátt loddrætt í miðjuni",
  "block.minecraft.banner.stripe_center.brown": "Brúnt loddrætt í miðjuni",
  "block.minecraft.banner.stripe_center.cyan": "Blágrønt loddrætt í miðjuni",
  "block.minecraft.banner.stripe_center.gray": "Grátt loddrætt í miðjuni",
  "block.minecraft.banner.stripe_center.green": "Grønt loddrætt í miðjuni",
  "block.minecraft.banner.stripe_center.light_blue": "Ljósablátt loddrætt í miðjuni",
  "block.minecraft.banner.stripe_center.light_gray": "Ljósagrátt loddrætt í miðjuni",
  "block.minecraft.banner.stripe_center.lime": "Ljósagrønt loddrætt í miðjuni",
  "block.minecraft.banner.stripe_center.magenta": "Viólreytt loddrætt í miðjuni",
  "block.minecraft.banner.stripe_center.orange": "Appilsingult loddrætt í miðjuni",
  "block.minecraft.banner.stripe_center.pink": "Ljósareytt loddrætt í miðjuni",
  "block.minecraft.banner.stripe_center.purple": "Lilla loddrætt í miðjuni",
  "block.minecraft.banner.stripe_center.red": "Reytt loddrætt í miðjuni",
  "block.minecraft.banner.stripe_center.white": "Hvítt loddrætt í miðjuni",
  "block.minecraft.banner.stripe_center.yellow": "Gult loddrætt í miðjuni",
  "block.minecraft.banner.stripe_downleft.black": "Svart øvut diagonalt",
  "block.minecraft.banner.stripe_downleft.blue": "Blátt øvut diagonalt",
  "block.minecraft.banner.stripe_downleft.brown": "Brúnt øvut diagonalt",
  "block.minecraft.banner.stripe_downleft.cyan": "Blágrønt øvut diagonalt",
  "block.minecraft.banner.stripe_downleft.gray": "Grátt øvut diagonalt",
  "block.minecraft.banner.stripe_downleft.green": "Grønt øvut diagonalt",
  "block.minecraft.banner.stripe_downleft.light_blue": "Ljósablátt øvut diagonalt",
  "block.minecraft.banner.stripe_downleft.light_gray": "Ljósagrátt øvut diagonalt",
  "block.minecraft.banner.stripe_downleft.lime": "Ljósagrønt øvut skák",
  "block.minecraft.banner.stripe_downleft.magenta": "Viólreytt øvut diagonalt",
  "block.minecraft.banner.stripe_downleft.orange": "Appilsingult øvut diagonalt",
  "block.minecraft.banner.stripe_downleft.pink": "Ljósareytt øvut diagonalt",
  "block.minecraft.banner.stripe_downleft.purple": "Lilla øvut diagonalt",
  "block.minecraft.banner.stripe_downleft.red": "Reytt øvut diagonalt",
  "block.minecraft.banner.stripe_downleft.white": "Hvítt øvut diagonalt",
  "block.minecraft.banner.stripe_downleft.yellow": "Gult øvut diagonalt",
  "block.minecraft.banner.stripe_downright.black": "Svart diagonalt",
  "block.minecraft.banner.stripe_downright.blue": "Blátt diagonalt",
  "block.minecraft.banner.stripe_downright.brown": "Brúnt diagonalt",
  "block.minecraft.banner.stripe_downright.cyan": "Blágrønt diagonalt",
  "block.minecraft.banner.stripe_downright.gray": "Grátt diagonalt",
  "block.minecraft.banner.stripe_downright.green": "Grønt diagonalt",
  "block.minecraft.banner.stripe_downright.light_blue": "Ljósablátt diagonalt",
  "block.minecraft.banner.stripe_downright.light_gray": "Ljósagrátt diagonalt",
  "block.minecraft.banner.stripe_downright.lime": "Ljósagrønt skák",
  "block.minecraft.banner.stripe_downright.magenta": "Viólreytt diagonalt",
  "block.minecraft.banner.stripe_downright.orange": "Appilsingult diagonalt",
  "block.minecraft.banner.stripe_downright.pink": "Ljósareytt diagonalt",
  "block.minecraft.banner.stripe_downright.purple": "Lilla diagonalt",
  "block.minecraft.banner.stripe_downright.red": "Reytt diagonalt",
  "block.minecraft.banner.stripe_downright.white": "Hvítt diagonalt",
  "block.minecraft.banner.stripe_downright.yellow": "Gult diagonalt",
  "block.minecraft.banner.stripe_left.black": "Svart vinstru megin",
  "block.minecraft.banner.stripe_left.blue": "Blátt vinstru megin",
  "block.minecraft.banner.stripe_left.brown": "Brúnt vinstru megin",
  "block.minecraft.banner.stripe_left.cyan": "Blágrønt vinstru megin",
  "block.minecraft.banner.stripe_left.gray": "Grátt vinstru megin",
  "block.minecraft.banner.stripe_left.green": "Grønt vinstru megin",
  "block.minecraft.banner.stripe_left.light_blue": "Ljósablátt vinstru megin",
  "block.minecraft.banner.stripe_left.light_gray": "Ljósagrátt vinstru megin",
  "block.minecraft.banner.stripe_left.lime": "Ljósagrønt vinstrumegin",
  "block.minecraft.banner.stripe_left.magenta": "Viólreytt vinstru megin",
  "block.minecraft.banner.stripe_left.orange": "Appilsingult vinstru megin",
  "block.minecraft.banner.stripe_left.pink": "Ljósareytt vinstru megin",
  "block.minecraft.banner.stripe_left.purple": "Lilla vinstru megin",
  "block.minecraft.banner.stripe_left.red": "Reytt vinstru megin",
  "block.minecraft.banner.stripe_left.white": "Hvítt vinstru megin",
  "block.minecraft.banner.stripe_left.yellow": "Gult vinstru megin",
  "block.minecraft.banner.stripe_middle.black": "Svart vatnrætt í miðjuni",
  "block.minecraft.banner.stripe_middle.blue": "Blátt vatnrætt í miðjuni",
  "block.minecraft.banner.stripe_middle.brown": "Brúnt vatnrætt í miðjuni",
  "block.minecraft.banner.stripe_middle.cyan": "Blágrønt vatnrætt í miðjuni",
  "block.minecraft.banner.stripe_middle.gray": "Grátt vatnrætt í miðjuni",
  "block.minecraft.banner.stripe_middle.green": "Grønt vatnrætt í miðjuni",
  "block.minecraft.banner.stripe_middle.light_blue": "Ljósablátt vatnrætt í miðjuni",
  "block.minecraft.banner.stripe_middle.light_gray": "Ljósagrátt vatnrætt í miðjuni",
  "block.minecraft.banner.stripe_middle.lime": "Ljósagrønt vatnrætt í miðjuni",
  "block.minecraft.banner.stripe_middle.magenta": "Viólreytt vatnrætt í miðjuni",
  "block.minecraft.banner.stripe_middle.orange": "Appilsingult vatnrætt í miðjuni",
  "block.minecraft.banner.stripe_middle.pink": "Ljósareytt vatnrætt í miðjuni",
  "block.minecraft.banner.stripe_middle.purple": "Lilla vatnrætt í miðjuni",
  "block.minecraft.banner.stripe_middle.red": "Reytt vatnrætt í miðjuni",
  "block.minecraft.banner.stripe_middle.white": "Hvítt vatnrætt í miðjuni",
  "block.minecraft.banner.stripe_middle.yellow": "Gult vatnrætt í miðjuni",
  "block.minecraft.banner.stripe_right.black": "Svart til høgru",
  "block.minecraft.banner.stripe_right.blue": "Blátt til høgru",
  "block.minecraft.banner.stripe_right.brown": "Brúnt til høgru",
  "block.minecraft.banner.stripe_right.cyan": "Blágrønt til høgru",
  "block.minecraft.banner.stripe_right.gray": "Grátt til høgru",
  "block.minecraft.banner.stripe_right.green": "Grønt til høgru",
  "block.minecraft.banner.stripe_right.light_blue": "Ljósablátt til høgru",
  "block.minecraft.banner.stripe_right.light_gray": "Ljósagrátt til høgru",
  "block.minecraft.banner.stripe_right.lime": "Ljósagrønt til høgru",
  "block.minecraft.banner.stripe_right.magenta": "Viólreytt til høgru",
  "block.minecraft.banner.stripe_right.orange": "Appilsingult til høgru",
  "block.minecraft.banner.stripe_right.pink": "Ljósareytt til høgru",
  "block.minecraft.banner.stripe_right.purple": "Lilla til høgru",
  "block.minecraft.banner.stripe_right.red": "Reytt til høgru",
  "block.minecraft.banner.stripe_right.white": "Hvítt til høgru",
  "block.minecraft.banner.stripe_right.yellow": "Gult til høgru",
  "block.minecraft.banner.stripe_top.black": "Svartur toppur",
  "block.minecraft.banner.stripe_top.blue": "Bláur toppur",
  "block.minecraft.banner.stripe_top.brown": "Brúnur toppur",
  "block.minecraft.banner.stripe_top.cyan": "Blágrønur toppur",
  "block.minecraft.banner.stripe_top.gray": "Gráur toppur",
  "block.minecraft.banner.stripe_top.green": "Grønur toppur",
  "block.minecraft.banner.stripe_top.light_blue": "Ljósabláur toppur",
  "block.minecraft.banner.stripe_top.light_gray": "Ljósagráur toppur",
  "block.minecraft.banner.stripe_top.lime": "Ljósagrønur toppur",
  "block.minecraft.banner.stripe_top.magenta": "Viólreyður toppur",
  "block.minecraft.banner.stripe_top.orange": "Appilsingulur toppur",
  "block.minecraft.banner.stripe_top.pink": "Ljósareyður toppur",
  "block.minecraft.banner.stripe_top.purple": "Lilla toppur",
  "block.minecraft.banner.stripe_top.red": "Reyður toppur",
  "block.minecraft.banner.stripe_top.white": "Hvítur toppur",
  "block.minecraft.banner.stripe_top.yellow": "Gulur toppur",
  "block.minecraft.banner.triangle_bottom.black": "Svartur tríkantur niðast",
  "block.minecraft.banner.triangle_bottom.blue": "Bláur tríkantur niðast",
  "block.minecraft.banner.triangle_bottom.brown": "Brúnur tríkantur niðast",
  "block.minecraft.banner.triangle_bottom.cyan": "Blágrønur tríkantur niðast",
  "block.minecraft.banner.triangle_bottom.gray": "Gráur tríkantur niðast",
  "block.minecraft.banner.triangle_bottom.green": "Grønur tríkantur niðast",
  "block.minecraft.banner.triangle_bottom.light_blue": "Ljósabláur tríkantur niðast",
  "block.minecraft.banner.triangle_bottom.light_gray": "Ljósagráur tríkantur niðast",
  "block.minecraft.banner.triangle_bottom.lime": "Ljósagrønur tríkantur niðast",
  "block.minecraft.banner.triangle_bottom.magenta": "Viólreyður tríkantur niðast",
  "block.minecraft.banner.triangle_bottom.orange": "Appilsingulur tríkantur niðast",
  "block.minecraft.banner.triangle_bottom.pink": "Ljósareyður tríkantur niðast",
  "block.minecraft.banner.triangle_bottom.purple": "Lilla tríkantur niðast",
  "block.minecraft.banner.triangle_bottom.red": "Reyður tríkantur niðast",
  "block.minecraft.banner.triangle_bottom.white": "Hvítur tríkantur niðast",
  "block.minecraft.banner.triangle_bottom.yellow": "Gulur tríkantur niðast",
  "block.minecraft.banner.triangle_top.black": "Svartur tríkantur ovast",
  "block.minecraft.banner.triangle_top.blue": "Bláur tríkantur ovast",
  "block.minecraft.banner.triangle_top.brown": "Brúnur tríkantur ovast",
  "block.minecraft.banner.triangle_top.cyan": "Blágrønur tríkantur ovast",
  "block.minecraft.banner.triangle_top.gray": "Gráur tríkantur ovast",
  "block.minecraft.banner.triangle_top.green": "Grønur tríkantur ovast",
  "block.minecraft.banner.triangle_top.light_blue": "Ljósabláur tríkantur ovast",
  "block.minecraft.banner.triangle_top.light_gray": "Ljósagráur tríkantur ovast",
  "block.minecraft.banner.triangle_top.lime": "Ljósagrønur tríkantur ovast",
  "block.minecraft.banner.triangle_top.magenta": "Viólreyður tríkantur ovast",
  "block.minecraft.banner.triangle_top.orange": "Appilsingulur tríkantur ovast",
  "block.minecraft.banner.triangle_top.pink": "Ljósareyður tríkantur ovast",
  "block.minecraft.banner.triangle_top.purple": "Lilla tríkantur ovast",
  "block.minecraft.banner.triangle_top.red": "Reyður tríkantur ovast",
  "block.minecraft.banner.triangle_top.white": "Hvítur tríkantur ovast",
  "block.minecraft.banner.triangle_top.yellow": "Gulur tríkantur ovast",
  "block.minecraft.banner.triangles_bottom.black": "Svartir tindar niðast",
  "block.minecraft.banner.triangles_bottom.blue": "Bláir tindar niðast",
  "block.minecraft.banner.triangles_bottom.brown": "Brúnir tindar niðast",
  "block.minecraft.banner.triangles_bottom.cyan": "Blágrønir tindar niðast",
  "block.minecraft.banner.triangles_bottom.gray": "Gráir tindar niðast",
  "block.minecraft.banner.triangles_bottom.green": "Grønir tindar niðast",
  "block.minecraft.banner.triangles_bottom.light_blue": "Ljósabláir tindar niðast",
  "block.minecraft.banner.triangles_bottom.light_gray": "Ljósagráir tindar niðast",
  "block.minecraft.banner.triangles_bottom.lime": "Ljósagrønir tindar niðast",
  "block.minecraft.banner.triangles_bottom.magenta": "Viólreyðir tindar niðast",
  "block.minecraft.banner.triangles_bottom.orange": "Appilsingulir tindar niðast",
  "block.minecraft.banner.triangles_bottom.pink": "Ljósareyðir tindar niðast",
  "block.minecraft.banner.triangles_bottom.purple": "Lilla tindar niðast",
  "block.minecraft.banner.triangles_bottom.red": "Reyðir tindar niðast",
  "block.minecraft.banner.triangles_bottom.white": "Hvítir tindar niðast",
  "block.minecraft.banner.triangles_bottom.yellow": "Gulir tindar niðast",
  "block.minecraft.banner.triangles_top.black": "Svartir tindar ovast",
  "block.minecraft.banner.triangles_top.blue": "Bláir tindar ovast",
  "block.minecraft.banner.triangles_top.brown": "Brúnir tindar ovast",
  "block.minecraft.banner.triangles_top.cyan": "Blágrønir tindar ovast",
  "block.minecraft.banner.triangles_top.gray": "Gráir tindar ovast",
  "block.minecraft.banner.triangles_top.green": "Grønir tindar ovast",
  "block.minecraft.banner.triangles_top.light_blue": "Ljósabláir tindar ovast",
  "block.minecraft.banner.triangles_top.light_gray": "Ljósagráir tindar ovast",
  "block.minecraft.banner.triangles_top.lime": "Ljósagrønir tindar ovast",
  "block.minecraft.banner.triangles_top.magenta": "Viólreyðir tindar ovast",
  "block.minecraft.banner.triangles_top.orange": "Appilsingulir tindar ovast",
  "block.minecraft.banner.triangles_top.pink": "Ljósareyðir tindar ovast",
  "block.minecraft.banner.triangles_top.purple": "Lilla tindar ovast",
  "block.minecraft.banner.triangles_top.red": "Reyðir tindar ovast",
  "block.minecraft.banner.triangles_top.white": "Hvítir tindar ovast",
  "block.minecraft.banner.triangles_top.yellow": "Gulir tindar ovast",
  "block.minecraft.barrel": "Tunna",
  "block.minecraft.barrier": "Forðanarkubbi",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Viti",
  "block.minecraft.beacon.primary": "Høvuðárin",
  "block.minecraft.beacon.secondary": "Hjáárin",
  "block.minecraft.bed.no_sleep": "Tú kanst bert sova um náttina ella í toruveðri",
  "block.minecraft.bed.not_safe": "Tú kanst ikki hvíla nú; skrímsl eru í nánd",
  "block.minecraft.bed.obstructed": "Songin er upptikin",
  "block.minecraft.bed.occupied": "Songin er upptikin",
  "block.minecraft.bed.too_far_away": "Tú kanst ikki hvíla nú; songin er ov langt burturi",
  "block.minecraft.bedrock": "Botnhella",
  "block.minecraft.bee_nest": "Býflugubøli",
  "block.minecraft.beehive": "Býflugubøli",
  "block.minecraft.beetroots": "Reyðrøtur",
  "block.minecraft.bell": "Ringiklokka",
  "block.minecraft.big_dripleaf": "Stórt dropablað",
  "block.minecraft.big_dripleaf_stem": "Stórur dropablaðsstelkur",
  "block.minecraft.birch_button": "Bjarkarknøttur",
  "block.minecraft.birch_door": "Bjarkarhurð",
  "block.minecraft.birch_fence": "Bjarkargirðing",
  "block.minecraft.birch_fence_gate": "Bjarkargrind",
  "block.minecraft.birch_hanging_sign": "Hangandi bjarkarskelti",
  "block.minecraft.birch_leaves": "Bjarkarbløð",
  "block.minecraft.birch_log": "Bjarkarstokkur",
  "block.minecraft.birch_planks": "Bjørkviður",
  "block.minecraft.birch_pressure_plate": "Bjarkartrýstpláta",
  "block.minecraft.birch_sapling": "Bjarkarspíri",
  "block.minecraft.birch_shelf": "Bókarhill",
  "block.minecraft.birch_sign": "Bjarkarskelti",
  "block.minecraft.birch_slab": "Bjarkarpláta",
  "block.minecraft.birch_stairs": "Bjarkartrappur",
  "block.minecraft.birch_trapdoor": "Bjarkarlemmur",
  "block.minecraft.birch_wall_hanging_sign": "Hangandi bjarkarveggskelti",
  "block.minecraft.birch_wall_sign": "Bjarkarveggskelti",
  "block.minecraft.birch_wood": "Bjarkartræ",
  "block.minecraft.black_banner": "Svart Flagg",
  "block.minecraft.black_bed": "Svørt Song",
  "block.minecraft.black_candle": "Svart kertiljós",
  "block.minecraft.black_candle_cake": "Kaka við svørtum kertiljósi",
  "block.minecraft.black_carpet": "Svart Teppi",
  "block.minecraft.black_concrete": "Svart betong",
  "block.minecraft.black_concrete_powder": "Svart betongpulvur",
  "block.minecraft.black_glazed_terracotta": "Svart glasað terrakotta",
  "block.minecraft.black_shulker_box": "Svartur shulkerkassi",
  "block.minecraft.black_stained_glass": "Svartlitt glas",
  "block.minecraft.black_stained_glass_pane": "Svartlittur rútur",
  "block.minecraft.black_terracotta": "Svart terrakotta",
  "block.minecraft.black_wool": "Svørt ull",
  "block.minecraft.blackstone": "Svartsteinur",
  "block.minecraft.blackstone_slab": "Svartsteinspláta",
  "block.minecraft.blackstone_stairs": "Svartsteinstrappa",
  "block.minecraft.blackstone_wall": "Svartsteinsveggur",
  "block.minecraft.blast_furnace": "Bræðingarovnur",
  "block.minecraft.blue_banner": "Blátt Flagg",
  "block.minecraft.blue_bed": "Blá Song",
  "block.minecraft.blue_candle": "Blátt kertiljós",
  "block.minecraft.blue_candle_cake": "Kaka við bláum kertiljósi",
  "block.minecraft.blue_carpet": "Blátt Teppi",
  "block.minecraft.blue_concrete": "Blátt betong",
  "block.minecraft.blue_concrete_powder": "Blátt betongpulvur",
  "block.minecraft.blue_glazed_terracotta": "Blátt glasað terrakotta",
  "block.minecraft.blue_ice": "Bláísur",
  "block.minecraft.blue_orchid": "Blá orkide",
  "block.minecraft.blue_shulker_box": "Bláur shulkerkassi",
  "block.minecraft.blue_stained_glass": "Blálitt glas",
  "block.minecraft.blue_stained_glass_pane": "Blálittur rútur",
  "block.minecraft.blue_terracotta": "Blátt terrakotta",
  "block.minecraft.blue_wool": "Blá ull",
  "block.minecraft.bone_block": "Beinkubbi",
  "block.minecraft.bookshelf": "Bókahill",
  "block.minecraft.brain_coral": "Heilakorall",
  "block.minecraft.brain_coral_block": "Heilakorallkubbi",
  "block.minecraft.brain_coral_fan": "Heilakorallveiftra",
  "block.minecraft.brain_coral_wall_fan": "Heilakorallveggjaveiftra",
  "block.minecraft.brewing_stand": "Bryggistøð",
  "block.minecraft.brick_slab": "Múrsteinspláta",
  "block.minecraft.brick_stairs": "Múrsteinstrappa",
  "block.minecraft.brick_wall": "Múrsteinsveggur",
  "block.minecraft.bricks": "Múrsteinar",
  "block.minecraft.brown_banner": "Brúnt Flagg",
  "block.minecraft.brown_bed": "Brún Song",
  "block.minecraft.brown_candle": "Brúnt kertiljós",
  "block.minecraft.brown_candle_cake": "Kaka við brúnum kertiljósi",
  "block.minecraft.brown_carpet": "Brúnt Teppi",
  "block.minecraft.brown_concrete": "Brúnt betong",
  "block.minecraft.brown_concrete_powder": "Brúnt betongpulvur",
  "block.minecraft.brown_glazed_terracotta": "Brúnt glasað terrakotta",
  "block.minecraft.brown_mushroom": "Brúnur soppur",
  "block.minecraft.brown_mushroom_block": "Brúnur soppakubbi",
  "block.minecraft.brown_shulker_box": "Brúnur shulkerkassi",
  "block.minecraft.brown_stained_glass": "Brúnlitt glas",
  "block.minecraft.brown_stained_glass_pane": "Brúnlittur rútur",
  "block.minecraft.brown_terracotta": "Brúnt terrakotta",
  "block.minecraft.brown_wool": "Brún ull",
  "block.minecraft.bubble_column": "Bløðrusúla",
  "block.minecraft.bubble_coral": "Bløðrukorall",
  "block.minecraft.bubble_coral_block": "Bløðrukorallkubbi",
  "block.minecraft.bubble_coral_fan": "Bløðrukorallveiftra",
  "block.minecraft.bubble_coral_wall_fan": "Bløðrukorallveggjaveiftra",
  "block.minecraft.budding_amethyst": "Sprettandi ametyst",
  "block.minecraft.bush": "Runnur",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktusblóma",
  "block.minecraft.cake": "Køka",
  "block.minecraft.calcite": "Kálkspatt",
  "block.minecraft.calibrated_sculk_sensor": "Stillaður sculkvarnari",
  "block.minecraft.campfire": "Bál",
  "block.minecraft.candle": "Kertiljós",
  "block.minecraft.candle_cake": "Kaka við kertiljósi",
  "block.minecraft.carrots": "Gularøtur",
  "block.minecraft.cartography_table": "Kortteknaraborð",
  "block.minecraft.carved_pumpkin": "Skorið grasker",
  "block.minecraft.cauldron": "Kar",
  "block.minecraft.cave_air": "Hellisluft",
  "block.minecraft.cave_vines": "Helluvínviður",
  "block.minecraft.cave_vines_plant": "Helluvínviðarplanta",
  "block.minecraft.chain": "Keta",
  "block.minecraft.chain_command_block": "Ketustýriboðskubbi",
  "block.minecraft.cherry_button": "Kirsuberjaknøttur",
  "block.minecraft.cherry_door": "Kirsuberjahurð",
  "block.minecraft.cherry_fence": "Kirsuberjagirðing",
  "block.minecraft.cherry_fence_gate": "Kirsuberjagrind",
  "block.minecraft.cherry_hanging_sign": "Hangandi kirsuberjaskelti",
  "block.minecraft.cherry_leaves": "Kirsuberjabløð",
  "block.minecraft.cherry_log": "Kirsuberjastokkur",
  "block.minecraft.cherry_planks": "Kirsuberjaviður",
  "block.minecraft.cherry_pressure_plate": "Kirsuberjatrýstpláta",
  "block.minecraft.cherry_sapling": "Kirsuberjaspíri",
  "block.minecraft.cherry_shelf": "Kirsuviðarhill",
  "block.minecraft.cherry_sign": "Kirsuberjaskelti",
  "block.minecraft.cherry_slab": "Kirsuberjapláta",
  "block.minecraft.cherry_stairs": "Kirsuberjatrappa",
  "block.minecraft.cherry_trapdoor": "Kirsuberjalemmur",
  "block.minecraft.cherry_wall_hanging_sign": "Hangandi kirsuberjaveggskelti",
  "block.minecraft.cherry_wall_sign": "Kirsuberjaveggskelti",
  "block.minecraft.cherry_wood": "Kirsuberjatræ",
  "block.minecraft.chest": "Kista",
  "block.minecraft.chipped_anvil": "Skaraður stiði",
  "block.minecraft.chiseled_bookshelf": "Meitlað bókahill",
  "block.minecraft.chiseled_copper": "Meitlað kopar",
  "block.minecraft.chiseled_deepslate": "Meitlað djúphella",
  "block.minecraft.chiseled_nether_bricks": "Meitlaðir nethermúrsteinar",
  "block.minecraft.chiseled_polished_blackstone": "Meitlaður pussaður svartsteinur",
  "block.minecraft.chiseled_quartz_block": "Meitlaður Kvartskubbi",
  "block.minecraft.chiseled_red_sandstone": "Meitlaður Reyðsandsteinur",
  "block.minecraft.chiseled_resin_bricks": "Meitlaðir harpeismúrsteinar",
  "block.minecraft.chiseled_sandstone": "Meitlaður Sandsteinur",
  "block.minecraft.chiseled_stone_bricks": "Meitlaðir steinmúrsteinar",
  "block.minecraft.chiseled_tuff": "Meitlað royðugrót",
  "block.minecraft.chiseled_tuff_bricks": "Meitlaðir royðumúrsteinar",
  "block.minecraft.chorus_flower": "Kórblóma",
  "block.minecraft.chorus_plant": "Kórstelkur",
  "block.minecraft.clay": "Leir",
  "block.minecraft.closed_eyeblossom": "Afturlatin eygablóma",
  "block.minecraft.coal_block": "Kolakubbi",
  "block.minecraft.coal_ore": "Kolamálmur",
  "block.minecraft.coarse_dirt": "Grov mold",
  "block.minecraft.cobbled_deepslate": "Djúphellubrúgvarsteinur",
  "block.minecraft.cobbled_deepslate_slab": "Djúphellubrúgvarsteinspláta",
  "block.minecraft.cobbled_deepslate_stairs": "Djúphellubrúgvarsteinstrappa",
  "block.minecraft.cobbled_deepslate_wall": "Djúphellubrúgvarsteinsveggur",
  "block.minecraft.cobblestone": "Brúgvarsteinur",
  "block.minecraft.cobblestone_slab": "Brúgvarsteinspláta",
  "block.minecraft.cobblestone_stairs": "Brúgvarsteinstrappa",
  "block.minecraft.cobblestone_wall": "Brúgvarsteinsveggur",
  "block.minecraft.cobweb": "Eiturfon",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Stýriboðskubbi",
  "block.minecraft.comparator": "Reyðgrýtissamanberi",
  "block.minecraft.composter": "Sóptaðartunna",
  "block.minecraft.conduit": "Fløðari",
  "block.minecraft.copper_bars": "Koparstengur",
  "block.minecraft.copper_block": "Koparkubbi",
  "block.minecraft.copper_bulb": "Copper Bulb",
  "block.minecraft.copper_chain": "Kopar keta",
  "block.minecraft.copper_chest": "Koparkista",
  "block.minecraft.copper_door": "Koparhurð",
  "block.minecraft.copper_golem_statue": "Standmynd av koparmenni",
  "block.minecraft.copper_grate": "Koparrist",
  "block.minecraft.copper_lantern": "Koparlykt",
  "block.minecraft.copper_ore": "Koparmálmur",
  "block.minecraft.copper_torch": "Kopar Kyndil",
  "block.minecraft.copper_trapdoor": "Koparlemmur",
  "block.minecraft.copper_wall_torch": "Koparkyndil",
  "block.minecraft.cornflower": "Kornblóma",
  "block.minecraft.cracked_deepslate_bricks": "Rivutir djúphellumúrsteinar",
  "block.minecraft.cracked_deepslate_tiles": "Rivutar djúphelluflísar",
  "block.minecraft.cracked_nether_bricks": "Rivutir nethermúrsteinar",
  "block.minecraft.cracked_polished_blackstone_bricks": "Rivutir pussaðir svartsteinsmúrsteinar",
  "block.minecraft.cracked_stone_bricks": "Rivutir steinmúrsteinar",
  "block.minecraft.crafter": "Evnari",
  "block.minecraft.crafting_table": "Arbeiðsborð",
  "block.minecraft.creaking_heart": "Knarranarhjarta",
  "block.minecraft.creeper_head": "Creeperhøvd",
  "block.minecraft.creeper_wall_head": "Creeperveggjahøvd",
  "block.minecraft.crimson_button": "Roðaknøttur",
  "block.minecraft.crimson_door": "Roðahurð",
  "block.minecraft.crimson_fence": "Roðagerðing",
  "block.minecraft.crimson_fence_gate": "Roðagrind",
  "block.minecraft.crimson_fungus": "Roðasoppur",
  "block.minecraft.crimson_hanging_sign": "Hangandi roðaskelti",
  "block.minecraft.crimson_hyphae": "Roðasoppatræðrir",
  "block.minecraft.crimson_nylium": "Roðanoppavevnaður",
  "block.minecraft.crimson_planks": "Roðaviður",
  "block.minecraft.crimson_pressure_plate": "Roðatrýstpláta",
  "block.minecraft.crimson_roots": "Roðarøtur",
  "block.minecraft.crimson_shelf": "Crimson Shelf",
  "block.minecraft.crimson_sign": "Roðaskelti",
  "block.minecraft.crimson_slab": "Roðapláta",
  "block.minecraft.crimson_stairs": "Roðatrappa",
  "block.minecraft.crimson_stem": "Roðastelkur",
  "block.minecraft.crimson_trapdoor": "Roðalemmur",
  "block.minecraft.crimson_wall_hanging_sign": "Hangandi roðaskelti",
  "block.minecraft.crimson_wall_sign": "Roðaskelti",
  "block.minecraft.crying_obsidian": "Grátandi ravntinna",
  "block.minecraft.cut_copper": "Skorið kopar",
  "block.minecraft.cut_copper_slab": "Skorin koparpláta",
  "block.minecraft.cut_copper_stairs": "Skorin kopartrappa",
  "block.minecraft.cut_red_sandstone": "Skorin reyðsandsteinur",
  "block.minecraft.cut_red_sandstone_slab": "Skorin reyðsandsteinspláta",
  "block.minecraft.cut_sandstone": "Skorin Sandsteinur",
  "block.minecraft.cut_sandstone_slab": "Skorin sandsteinspláta",
  "block.minecraft.cyan_banner": "Blágrønt Flagg",
  "block.minecraft.cyan_bed": "Blágrøn song",
  "block.minecraft.cyan_candle": "Blágrønt kertiljós",
  "block.minecraft.cyan_candle_cake": "Kaka við blágrønum kertiljósi",
  "block.minecraft.cyan_carpet": "Blágrønt Teppi",
  "block.minecraft.cyan_concrete": "Blágrønt betong",
  "block.minecraft.cyan_concrete_powder": "Blágrønt betongpulvur",
  "block.minecraft.cyan_glazed_terracotta": "Blágrønt glasað terrakotta",
  "block.minecraft.cyan_shulker_box": "Blágrønur shulkerkassi",
  "block.minecraft.cyan_stained_glass": "Blágrønlitt glas",
  "block.minecraft.cyan_stained_glass_pane": "Blágrønlittur rútur",
  "block.minecraft.cyan_terracotta": "Blágrønt terrakotta",
  "block.minecraft.cyan_wool": "Blágrøn ull",
  "block.minecraft.damaged_anvil": "Illfarin stiði",
  "block.minecraft.dandelion": "Hagasólja",
  "block.minecraft.dark_oak_button": "Myrkur eikiknøttur",
  "block.minecraft.dark_oak_door": "Myrk eikihurð",
  "block.minecraft.dark_oak_fence": "Myrk eikigirðing",
  "block.minecraft.dark_oak_fence_gate": "Myrk eikigrind",
  "block.minecraft.dark_oak_hanging_sign": "Hangandi myrkt eikiskelti",
  "block.minecraft.dark_oak_leaves": "Myrk eikibløð",
  "block.minecraft.dark_oak_log": "Myrkur eikistokkur",
  "block.minecraft.dark_oak_planks": "Myrkur eikiviður",
  "block.minecraft.dark_oak_pressure_plate": "Myrk eikitrýstpláta",
  "block.minecraft.dark_oak_sapling": "Myrkur eikispíri",
  "block.minecraft.dark_oak_shelf": "Dark Oak Shelf",
  "block.minecraft.dark_oak_sign": "Myrkt eikiskelti",
  "block.minecraft.dark_oak_slab": "Myrk eikipláta",
  "block.minecraft.dark_oak_stairs": "Myrk eikitrappa",
  "block.minecraft.dark_oak_trapdoor": "Myrkur eikilemmur",
  "block.minecraft.dark_oak_wall_hanging_sign": "Hangandi myrkt eikiveggskelti",
  "block.minecraft.dark_oak_wall_sign": "Myrkt eikiveggskelti",
  "block.minecraft.dark_oak_wood": "Myrkt eikitræ",
  "block.minecraft.dark_prismarine": "Myrkt Prismarin",
  "block.minecraft.dark_prismarine_slab": "Myrk prismarinpláta",
  "block.minecraft.dark_prismarine_stairs": "Myrkar prismarintrappa",
  "block.minecraft.daylight_detector": "Dagsljóssensorur",
  "block.minecraft.dead_brain_coral": "Deyð heilakorall",
  "block.minecraft.dead_brain_coral_block": "Deyður heilakorallkubbi",
  "block.minecraft.dead_brain_coral_fan": "Deyð heilakorallveiftra",
  "block.minecraft.dead_brain_coral_wall_fan": "Deyð heilakorallveggjaveiftra",
  "block.minecraft.dead_bubble_coral": "Deyð bløðrukorall",
  "block.minecraft.dead_bubble_coral_block": "Deyður bløðrukorallkubbi",
  "block.minecraft.dead_bubble_coral_fan": "Deyð bløðrukorallveiftra",
  "block.minecraft.dead_bubble_coral_wall_fan": "Deyð bløðrukorallveggjaveiftra",
  "block.minecraft.dead_bush": "Deyður runnur",
  "block.minecraft.dead_fire_coral": "Deyð eldkorall",
  "block.minecraft.dead_fire_coral_block": "Deyður eldkorallkubbi",
  "block.minecraft.dead_fire_coral_fan": "Deyð eldkorallveiftra",
  "block.minecraft.dead_fire_coral_wall_fan": "Deyð eldkorallveggjaveiftra",
  "block.minecraft.dead_horn_coral": "Deyð hornkorall",
  "block.minecraft.dead_horn_coral_block": "Deyður hornkorallkubbi",
  "block.minecraft.dead_horn_coral_fan": "Deyð hornkorallveiftra",
  "block.minecraft.dead_horn_coral_wall_fan": "Deyð hornkorallveggjaveiftra",
  "block.minecraft.dead_tube_coral": "Deyð pípukorall",
  "block.minecraft.dead_tube_coral_block": "Deyður pípukorallkubbi",
  "block.minecraft.dead_tube_coral_fan": "Deyð pípukorallveiftra",
  "block.minecraft.dead_tube_coral_wall_fan": "Deyð pípukorallveggjaveiftra",
  "block.minecraft.decorated_pot": "Prýddur pottur",
  "block.minecraft.deepslate": "Djúphella",
  "block.minecraft.deepslate_brick_slab": "Djúphellumúrsteinspláta",
  "block.minecraft.deepslate_brick_stairs": "Djúphellumúrsteinstrappa",
  "block.minecraft.deepslate_brick_wall": "Djúphellumúrsteinsveggur",
  "block.minecraft.deepslate_bricks": "Djúphellumúrsteinar",
  "block.minecraft.deepslate_coal_ore": "Djúphellukolamálmur",
  "block.minecraft.deepslate_copper_ore": "Djúphellukoparmálmur",
  "block.minecraft.deepslate_diamond_ore": "Djúphelludiamantmálmur",
  "block.minecraft.deepslate_emerald_ore": "Djúphellusmaragdmálmur",
  "block.minecraft.deepslate_gold_ore": "Djúphellugullmálmur",
  "block.minecraft.deepslate_iron_ore": "Djúphellujarnmálmur",
  "block.minecraft.deepslate_lapis_ore": "Djúphelluasurmálmur",
  "block.minecraft.deepslate_redstone_ore": "Djúphellureyðgrýtismálmur",
  "block.minecraft.deepslate_tile_slab": "Djúphelluflísapláta",
  "block.minecraft.deepslate_tile_stairs": "Djúphelluflísatrappa",
  "block.minecraft.deepslate_tile_wall": "Djúphelluflísaveggur",
  "block.minecraft.deepslate_tiles": "Djúphelluflísar",
  "block.minecraft.detector_rail": "Sensorskinnari",
  "block.minecraft.diamond_block": "Diamantkubbi",
  "block.minecraft.diamond_ore": "Diamantmálmur",
  "block.minecraft.diorite": "Dioritt",
  "block.minecraft.diorite_slab": "Diorittpláta",
  "block.minecraft.diorite_stairs": "Dioritttrappa",
  "block.minecraft.diorite_wall": "Diorittveggur",
  "block.minecraft.dirt": "Mold",
  "block.minecraft.dirt_path": "Moldgøta",
  "block.minecraft.dispenser": "Útveitari",
  "block.minecraft.dragon_egg": "Drekaegg",
  "block.minecraft.dragon_head": "Drekahøvd",
  "block.minecraft.dragon_wall_head": "Drekaveggjahøvd",
  "block.minecraft.dried_ghast": "Dried Ghast",
  "block.minecraft.dried_kelp_block": "Turkaður tarakubbi",
  "block.minecraft.dripstone_block": "Dropasteinskubbi",
  "block.minecraft.dropper": "Útspýtari",
  "block.minecraft.emerald_block": "Smaragdkubbi",
  "block.minecraft.emerald_ore": "Smaragdmálmur",
  "block.minecraft.enchanting_table": "Gandaborð",
  "block.minecraft.end_gateway": "Endportur",
  "block.minecraft.end_portal": "Endamunni",
  "block.minecraft.end_portal_frame": "Endamunnakarmur",
  "block.minecraft.end_rod": "End-stong",
  "block.minecraft.end_stone": "Endsteinur",
  "block.minecraft.end_stone_brick_slab": "Endsteinsmúrsteinspláta",
  "block.minecraft.end_stone_brick_stairs": "Endsteinsmúrsteinstrappa",
  "block.minecraft.end_stone_brick_wall": "Endsteinsmúrsteinsveggur",
  "block.minecraft.end_stone_bricks": "Endsteinsmúrsteinar",
  "block.minecraft.ender_chest": "Enderkista",
  "block.minecraft.exposed_chiseled_copper": "Áfallið Meitlað Kopar",
  "block.minecraft.exposed_copper": "Áfallið Kopar",
  "block.minecraft.exposed_copper_bars": "Voksaðar Áfalnar Koparstengur",
  "block.minecraft.exposed_copper_bulb": "Áfallin Koparlykt",
  "block.minecraft.exposed_copper_chain": "Áfallin Koparketa",
  "block.minecraft.exposed_copper_chest": "Áfallin Koparkista",
  "block.minecraft.exposed_copper_door": "Áfallin Koparhurð",
  "block.minecraft.exposed_copper_golem_statue": "Áfallið Koparevnismenni",
  "block.minecraft.exposed_copper_grate": "Áfallin Koparrist",
  "block.minecraft.exposed_copper_lantern": "Áfallin Koparlykt",
  "block.minecraft.exposed_copper_trapdoor": "Áfallin koparlemmur",
  "block.minecraft.exposed_cut_copper": "Áfallið skorið kopar",
  "block.minecraft.exposed_cut_copper_slab": "Áfallin skorin koparpláta",
  "block.minecraft.exposed_cut_copper_stairs": "Áfallin skorin kopartrappa",
  "block.minecraft.exposed_lightning_rod": "Voksaður Áfallin Toruleiðari",
  "block.minecraft.farmland": "Landbúnaðarjørð",
  "block.minecraft.fern": "Trøllakampur",
  "block.minecraft.fire": "Eldur",
  "block.minecraft.fire_coral": "Eldkorall",
  "block.minecraft.fire_coral_block": "Eldkorallkubbi",
  "block.minecraft.fire_coral_fan": "Eldkorallveiftra",
  "block.minecraft.fire_coral_wall_fan": "Eldkorallveggjaveiftra",
  "block.minecraft.firefly_bush": "Eldflugurunnur",
  "block.minecraft.fletching_table": "Pílamakaraborð",
  "block.minecraft.flower_pot": "Urtapottur",
  "block.minecraft.flowering_azalea": "Blomstrandi asalea",
  "block.minecraft.flowering_azalea_leaves": "Blómstrandi asaleubløð",
  "block.minecraft.frogspawn": "Froskarogn",
  "block.minecraft.frosted_ice": "Rímfallin ísur",
  "block.minecraft.furnace": "Ovnur",
  "block.minecraft.gilded_blackstone": "Gyltur svartsteinur",
  "block.minecraft.glass": "Glas",
  "block.minecraft.glass_pane": "Rútur",
  "block.minecraft.glow_lichen": "Gløðiskón",
  "block.minecraft.glowstone": "Gløðisteinur",
  "block.minecraft.gold_block": "Gullkubbi",
  "block.minecraft.gold_ore": "Gullmálmur",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "Granitt",
  "block.minecraft.granite_slab": "Granittpláta",
  "block.minecraft.granite_stairs": "Granitttrappa",
  "block.minecraft.granite_wall": "Granittveggur",
  "block.minecraft.grass": "Gras",
  "block.minecraft.grass_block": "Graskubbi",
  "block.minecraft.gravel": "Eyrur",
  "block.minecraft.gray_banner": "Grátt Flagg",
  "block.minecraft.gray_bed": "Grá Song",
  "block.minecraft.gray_candle": "Grátt kertiljós",
  "block.minecraft.gray_candle_cake": "Kaka við gráum kertiljósi",
  "block.minecraft.gray_carpet": "Grátt Teppi",
  "block.minecraft.gray_concrete": "Grátt betong",
  "block.minecraft.gray_concrete_powder": "Grátt betongpulvur",
  "block.minecraft.gray_glazed_terracotta": "Grátt glasað terrakotta",
  "block.minecraft.gray_shulker_box": "Gráur shulkerkassi",
  "block.minecraft.gray_stained_glass": "Grálitt glas",
  "block.minecraft.gray_stained_glass_pane": "Grálittur rútur",
  "block.minecraft.gray_terracotta": "Grátt terrakotta",
  "block.minecraft.gray_wool": "Grá ull",
  "block.minecraft.green_banner": "Grønt Flagg",
  "block.minecraft.green_bed": "Grøn Song",
  "block.minecraft.green_candle": "Grønt kertiljós",
  "block.minecraft.green_candle_cake": "Kaka við grønum kertiljósi",
  "block.minecraft.green_carpet": "Grønt Teppi",
  "block.minecraft.green_concrete": "Grønt betong",
  "block.minecraft.green_concrete_powder": "Grønt betongpulvur",
  "block.minecraft.green_glazed_terracotta": "Grønt glasað terrakotta",
  "block.minecraft.green_shulker_box": "Grønur shulkerkassi",
  "block.minecraft.green_stained_glass": "Grønlitt glas",
  "block.minecraft.green_stained_glass_pane": "Grønlittur rútur",
  "block.minecraft.green_terracotta": "Grønt terrakotta",
  "block.minecraft.green_wool": "Grøn ull",
  "block.minecraft.grindstone": "Hvørvisteinur",
  "block.minecraft.hanging_roots": "Hangandi røtur",
  "block.minecraft.hay_block": "Hoyballa",
  "block.minecraft.heavy_core": "Tung kjarna",
  "block.minecraft.heavy_weighted_pressure_plate": "Tungvigað trýstpláta",
  "block.minecraft.honey_block": "Hunangskubbi",
  "block.minecraft.honeycomb_block": "Býflugukøkukubbi",
  "block.minecraft.hopper": "Trakt",
  "block.minecraft.horn_coral": "Hornkorall",
  "block.minecraft.horn_coral_block": "Hornkorallkubbi",
  "block.minecraft.horn_coral_fan": "Hornkorallveiftra",
  "block.minecraft.horn_coral_wall_fan": "Hornkorallveggjaveiftra",
  "block.minecraft.ice": "Ísur",
  "block.minecraft.infested_chiseled_stone_bricks": "Plágaðir meitlaðir steinmúrsteinar",
  "block.minecraft.infested_cobblestone": "Plágaður brúgvarsteinur",
  "block.minecraft.infested_cracked_stone_bricks": "Plágaðir rivutir steinmúrsteinar",
  "block.minecraft.infested_deepslate": "Plágað djúphella",
  "block.minecraft.infested_mossy_stone_bricks": "Plágaðir mosagrónir steinmúrsteinar",
  "block.minecraft.infested_stone": "Plágaður steinur",
  "block.minecraft.infested_stone_bricks": "Plágaðir steinmúrsteinar",
  "block.minecraft.iron_bars": "Jarnrimar",
  "block.minecraft.iron_block": "Jarnkubbi",
  "block.minecraft.iron_chain": "Jarnketa",
  "block.minecraft.iron_door": "Jarnhurð",
  "block.minecraft.iron_ore": "Jarnmálmur",
  "block.minecraft.iron_trapdoor": "Jarnlemmur",
  "block.minecraft.jack_o_lantern": "Graskerjalykt",
  "block.minecraft.jigsaw": "Putlispælskubbi",
  "block.minecraft.jukebox": "Jukebox",
  "block.minecraft.jungle_button": "Frumskóðarknøttur",
  "block.minecraft.jungle_door": "Frumskógarhurð",
  "block.minecraft.jungle_fence": "Frumskógargirðing",
  "block.minecraft.jungle_fence_gate": "Frumskógargrind",
  "block.minecraft.jungle_hanging_sign": "Hangandi frumskógarskelti",
  "block.minecraft.jungle_leaves": "Frumskógarbløð",
  "block.minecraft.jungle_log": "Frumskógarstokkur",
  "block.minecraft.jungle_planks": "Frumskógarviður",
  "block.minecraft.jungle_pressure_plate": "Frumskógartrýstpláta",
  "block.minecraft.jungle_sapling": "Frúmskógarspíri",
  "block.minecraft.jungle_shelf": "Frumskógaviðarhill",
  "block.minecraft.jungle_sign": "Frumskógarskelti",
  "block.minecraft.jungle_slab": "Frumskógarpláta",
  "block.minecraft.jungle_stairs": "Frumskógartrappa",
  "block.minecraft.jungle_trapdoor": "Frumskógarlemmur",
  "block.minecraft.jungle_wall_hanging_sign": "Hangandi frumskógarveggskelti",
  "block.minecraft.jungle_wall_sign": "Frumskógarveggskelti",
  "block.minecraft.jungle_wood": "Frumskógartræ",
  "block.minecraft.kelp": "Tari",
  "block.minecraft.kelp_plant": "Taraplanta",
  "block.minecraft.ladder": "Stigi",
  "block.minecraft.lantern": "Lykt",
  "block.minecraft.lapis_block": "Asursteinskubbi",
  "block.minecraft.lapis_ore": "Asurmálmur",
  "block.minecraft.large_amethyst_bud": "Stórur ametystknubbi",
  "block.minecraft.large_fern": "Stórur trøllakampur",
  "block.minecraft.lava": "Gos",
  "block.minecraft.lava_cauldron": "Goskar",
  "block.minecraft.leaf_litter": "Leyvstroyggj",
  "block.minecraft.lectern": "Lesipultur",
  "block.minecraft.lever": "Handtak",
  "block.minecraft.light": "Ljós",
  "block.minecraft.light_blue_banner": "Ljósablátt Flagg",
  "block.minecraft.light_blue_bed": "Ljósablá song",
  "block.minecraft.light_blue_candle": "Ljósablátt kertiljós",
  "block.minecraft.light_blue_candle_cake": "Kaka við ljósabláum kertiljósi",
  "block.minecraft.light_blue_carpet": "Ljósablátt Teppi",
  "block.minecraft.light_blue_concrete": "Ljósablátt betong",
  "block.minecraft.light_blue_concrete_powder": "Ljósablátt betongpulvur",
  "block.minecraft.light_blue_glazed_terracotta": "Ljósablátt glasað terrakotta",
  "block.minecraft.light_blue_shulker_box": "Ljósabláur shulkerkassi",
  "block.minecraft.light_blue_stained_glass": "Ljósablálitt glas",
  "block.minecraft.light_blue_stained_glass_pane": "Ljósablálittur rútur",
  "block.minecraft.light_blue_terracotta": "Ljósablátt terrakotta",
  "block.minecraft.light_blue_wool": "Ljósablá ull",
  "block.minecraft.light_gray_banner": "Ljósagrátt Flagg",
  "block.minecraft.light_gray_bed": "Ljósagrá song",
  "block.minecraft.light_gray_candle": "Ljósagrátt kertiljós",
  "block.minecraft.light_gray_candle_cake": "Kaka við ljósagráum kertiljósi",
  "block.minecraft.light_gray_carpet": "Ljósagrátt Teppi",
  "block.minecraft.light_gray_concrete": "Ljósagrátt betong",
  "block.minecraft.light_gray_concrete_powder": "Ljósagrátt betongpulvur",
  "block.minecraft.light_gray_glazed_terracotta": "Ljósagrátt glasað terrakotta",
  "block.minecraft.light_gray_shulker_box": "Ljósagráur shulkerkassi",
  "block.minecraft.light_gray_stained_glass": "Ljósagrálitt glas",
  "block.minecraft.light_gray_stained_glass_pane": "Ljósagrálittur rútur",
  "block.minecraft.light_gray_terracotta": "Ljósagrátt terrakotta",
  "block.minecraft.light_gray_wool": "Ljósagrá ull",
  "block.minecraft.light_weighted_pressure_plate": "Lættvigað trýstpláta",
  "block.minecraft.lightning_rod": "Toruverji",
  "block.minecraft.lilac": "Sírena",
  "block.minecraft.lily_of_the_valley": "Dalalilja",
  "block.minecraft.lily_pad": "Nyksblóma",
  "block.minecraft.lime_banner": "Ljósagrønt Flagg",
  "block.minecraft.lime_bed": "Ljósagrøn song",
  "block.minecraft.lime_candle": "Ljósagrønt kertiljós",
  "block.minecraft.lime_candle_cake": "Kaka við ljósagrønum kertiljósi",
  "block.minecraft.lime_carpet": "Ljósagrønt teppi",
  "block.minecraft.lime_concrete": "Ljósagrønt betong",
  "block.minecraft.lime_concrete_powder": "Ljósagrønt betongpulvur",
  "block.minecraft.lime_glazed_terracotta": "Ljósagrønt glasað terrakotta",
  "block.minecraft.lime_shulker_box": "Ljósagrønur shulkerkassi",
  "block.minecraft.lime_stained_glass": "Ljósagrønlitt glas",
  "block.minecraft.lime_stained_glass_pane": "Ljósagrønlittur rútur",
  "block.minecraft.lime_terracotta": "Ljósagrønt terrakotta",
  "block.minecraft.lime_wool": "Ljósagrøn Ull",
  "block.minecraft.lodestone": "Sigulsteinur",
  "block.minecraft.loom": "Vevur",
  "block.minecraft.magenta_banner": "Viólreytt Flagg",
  "block.minecraft.magenta_bed": "Viólreyð song",
  "block.minecraft.magenta_candle": "Viólreytt kertiljós",
  "block.minecraft.magenta_candle_cake": "Kaka við viólreyðum kertiljósi",
  "block.minecraft.magenta_carpet": "Viólreytt Teppi",
  "block.minecraft.magenta_concrete": "Viólreytt betong",
  "block.minecraft.magenta_concrete_powder": "Viólreytt betongpulvur",
  "block.minecraft.magenta_glazed_terracotta": "Viólreytt glasað terrakotta",
  "block.minecraft.magenta_shulker_box": "Viólreyður shulkerkassi",
  "block.minecraft.magenta_stained_glass": "Viólreyðlitt glas",
  "block.minecraft.magenta_stained_glass_pane": "Viólreyðlittur rútur",
  "block.minecraft.magenta_terracotta": "Viólreytt terrakotta",
  "block.minecraft.magenta_wool": "Viólreyð ull",
  "block.minecraft.magma_block": "Magmakubbi",
  "block.minecraft.mangrove_button": "Mangrovuknøttur",
  "block.minecraft.mangrove_door": "Mangrovuhurð",
  "block.minecraft.mangrove_fence": "Mangrovugirðing",
  "block.minecraft.mangrove_fence_gate": "Mangrovugrind",
  "block.minecraft.mangrove_hanging_sign": "Hangandi mangrovuskelti",
  "block.minecraft.mangrove_leaves": "Mangrovubløð",
  "block.minecraft.mangrove_log": "Mangrovustokkur",
  "block.minecraft.mangrove_planks": "Mangrovuviður",
  "block.minecraft.mangrove_pressure_plate": "Mangrovutrýstpláta",
  "block.minecraft.mangrove_propagule": "Mangrovunøringarkorn",
  "block.minecraft.mangrove_roots": "Mangrovurøtur",
  "block.minecraft.mangrove_shelf": "Mangrovuviðarhill",
  "block.minecraft.mangrove_sign": "Mangrovuskelti",
  "block.minecraft.mangrove_slab": "Mangrovupláta",
  "block.minecraft.mangrove_stairs": "Mangrovutrappa",
  "block.minecraft.mangrove_trapdoor": "Mangrovulemmur",
  "block.minecraft.mangrove_wall_hanging_sign": "Hangandi mangrovuveggskelti",
  "block.minecraft.mangrove_wall_sign": "Mangrovuveggskelti",
  "block.minecraft.mangrove_wood": "Mangrovutræ",
  "block.minecraft.medium_amethyst_bud": "Miðalstórur ametystknubbi",
  "block.minecraft.melon": "Vatnmelón",
  "block.minecraft.melon_stem": "Vatnmelónsstelkur",
  "block.minecraft.moss_block": "Mosakubbi",
  "block.minecraft.moss_carpet": "Mosateppi",
  "block.minecraft.mossy_cobblestone": "Mosagrógvin brúgvarsteinur",
  "block.minecraft.mossy_cobblestone_slab": "Mosagrógvin brúgvarsteinspláta",
  "block.minecraft.mossy_cobblestone_stairs": "Mosagrógvin brúgvarsteinstrappa",
  "block.minecraft.mossy_cobblestone_wall": "Mosagrógvin brúgvarsteinsveggur",
  "block.minecraft.mossy_stone_brick_slab": "Mosagrógvin múrsteinspláta",
  "block.minecraft.mossy_stone_brick_stairs": "Mosagrógvin steinmúrsteinstrappa",
  "block.minecraft.mossy_stone_brick_wall": "Mosagrógvin steinmúrsteinsveggur",
  "block.minecraft.mossy_stone_bricks": "Mosagrónir steinmúrsteinar",
  "block.minecraft.moving_piston": "Stempul í rørslu",
  "block.minecraft.mud": "Móra",
  "block.minecraft.mud_brick_slab": "Mórumúrsteinspláta",
  "block.minecraft.mud_brick_stairs": "Mórumúrsteinstrappa",
  "block.minecraft.mud_brick_wall": "Mórumúrsteinsveggur",
  "block.minecraft.mud_bricks": "Mórumúrsteinar",
  "block.minecraft.muddy_mangrove_roots": "Mórutar mangrovurøtur",
  "block.minecraft.mushroom_stem": "Soppastelkur",
  "block.minecraft.mycelium": "Soppmóðir",
  "block.minecraft.nether_brick_fence": "Nethermúrsteinsgirðing",
  "block.minecraft.nether_brick_slab": "Nethermúrsteinspláta",
  "block.minecraft.nether_brick_stairs": "Nethermúrsteinstrappa",
  "block.minecraft.nether_brick_wall": "Nethermúrsteinsveggur",
  "block.minecraft.nether_bricks": "Nethermúrsteinar",
  "block.minecraft.nether_gold_ore": "Nethergullmálmur",
  "block.minecraft.nether_portal": "Nethermunni",
  "block.minecraft.nether_quartz_ore": "Netherkvartsgrýti",
  "block.minecraft.nether_sprouts": "Netherspírar",
  "block.minecraft.nether_wart": "Netherfinnur",
  "block.minecraft.nether_wart_block": "Netherfinnukubbi",
  "block.minecraft.netherite_block": "Netherittkubbi",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Nótakubbi",
  "block.minecraft.oak_button": "Eikiknøttur",
  "block.minecraft.oak_door": "Eikihurð",
  "block.minecraft.oak_fence": "Eikigirðing",
  "block.minecraft.oak_fence_gate": "Eikigrind",
  "block.minecraft.oak_hanging_sign": "Hangandi eikiskelti",
  "block.minecraft.oak_leaves": "Eikibløð",
  "block.minecraft.oak_log": "Eikistokkur",
  "block.minecraft.oak_planks": "Eikiviður",
  "block.minecraft.oak_pressure_plate": "Eikitrýstpláta",
  "block.minecraft.oak_sapling": "Eikispíri",
  "block.minecraft.oak_shelf": "Eikihill",
  "block.minecraft.oak_sign": "Eikiskelti",
  "block.minecraft.oak_slab": "Eikipláta",
  "block.minecraft.oak_stairs": "Eikitrappa",
  "block.minecraft.oak_trapdoor": "Eikilemmur",
  "block.minecraft.oak_wall_hanging_sign": "Hangandi eikiveggskelti",
  "block.minecraft.oak_wall_sign": "Eikiveggskelti",
  "block.minecraft.oak_wood": "Eikitræ",
  "block.minecraft.observer": "Eygleiðari",
  "block.minecraft.obsidian": "Ravntinna",
  "block.minecraft.ochre_froglight": "Reyðgult froskljós",
  "block.minecraft.ominous_banner": "Ávaringarflagg",
  "block.minecraft.open_eyeblossom": "Opin eygablóma",
  "block.minecraft.orange_banner": "Appilsingult Flagg",
  "block.minecraft.orange_bed": "Appilsingul song",
  "block.minecraft.orange_candle": "Appilsingult kertiljós",
  "block.minecraft.orange_candle_cake": "Kaka við appilsingulum kertiljósi",
  "block.minecraft.orange_carpet": "Appilsingult Teppi",
  "block.minecraft.orange_concrete": "Appilsingult betong",
  "block.minecraft.orange_concrete_powder": "Appilsingult betongpulvur",
  "block.minecraft.orange_glazed_terracotta": "Appilsingult glasað terrakotta",
  "block.minecraft.orange_shulker_box": "Appilsingulur shulkerkassi",
  "block.minecraft.orange_stained_glass": "Appilsingullitt glas",
  "block.minecraft.orange_stained_glass_pane": "Appilsingullittur rútur",
  "block.minecraft.orange_terracotta": "Appilsingult terrakotta",
  "block.minecraft.orange_tulip": "Appilsingul tulipan",
  "block.minecraft.orange_wool": "Appilsingul ull",
  "block.minecraft.oxeye_daisy": "Hvítt oksaeyga",
  "block.minecraft.oxidized_chiseled_copper": "Súrevnað meitlað kopar",
  "block.minecraft.oxidized_copper": "Súrevnað kopar",
  "block.minecraft.oxidized_copper_bars": "Eirgingnar Koparstengur",
  "block.minecraft.oxidized_copper_bulb": "Súrevnað koparlykt",
  "block.minecraft.oxidized_copper_chain": "Eirgingin Koparketa",
  "block.minecraft.oxidized_copper_chest": "Eirgingin Koparkista",
  "block.minecraft.oxidized_copper_door": "Súrevnað koparhurð",
  "block.minecraft.oxidized_copper_golem_statue": "Eirgingið Koparevnismenni",
  "block.minecraft.oxidized_copper_grate": "Súrevnað koparrist",
  "block.minecraft.oxidized_copper_lantern": "Eirgingin Koparlykt",
  "block.minecraft.oxidized_copper_trapdoor": "Súrevnaður koparlemmur",
  "block.minecraft.oxidized_cut_copper": "Súrevnað skorið kopar",
  "block.minecraft.oxidized_cut_copper_slab": "Súrevnað skorin koparpláta",
  "block.minecraft.oxidized_cut_copper_stairs": "Súrevnað skorin kopartrappa",
  "block.minecraft.oxidized_lightning_rod": "Eirgingin Toruleiðari",
  "block.minecraft.packed_ice": "Pakkísur",
  "block.minecraft.packed_mud": "Stappað móra",
  "block.minecraft.pale_hanging_moss": "Hangandi bleikmosi",
  "block.minecraft.pale_moss_block": "Bleikmosakubbi",
  "block.minecraft.pale_moss_carpet": "Bleikmosateppi",
  "block.minecraft.pale_oak_button": "Bleikur eikiknøttur",
  "block.minecraft.pale_oak_door": "Bleik eikihurð",
  "block.minecraft.pale_oak_fence": "Bleik eikigirðing",
  "block.minecraft.pale_oak_fence_gate": "Bleik eikigrind",
  "block.minecraft.pale_oak_hanging_sign": "Hangandi bleikt eikiskelti",
  "block.minecraft.pale_oak_leaves": "Bleik eikibløð",
  "block.minecraft.pale_oak_log": "Bleikur eikistokkur",
  "block.minecraft.pale_oak_planks": "Bleikur eikiviður",
  "block.minecraft.pale_oak_pressure_plate": "Bleik eikitrýstpláta",
  "block.minecraft.pale_oak_sapling": "Bleikur eikispíri",
  "block.minecraft.pale_oak_shelf": "Bleik Eikihill",
  "block.minecraft.pale_oak_sign": "Bleikt eikiskelti",
  "block.minecraft.pale_oak_slab": "Bleik eikipláta",
  "block.minecraft.pale_oak_stairs": "Bleik eikitrappa",
  "block.minecraft.pale_oak_trapdoor": "Bleikur eikilemmur",
  "block.minecraft.pale_oak_wall_hanging_sign": "Hangandi bleikt eikiveggskelti",
  "block.minecraft.pale_oak_wall_sign": "Bleikt eikiveggskelti",
  "block.minecraft.pale_oak_wood": "Bleikt eikitræ",
  "block.minecraft.pearlescent_froglight": "Perlublátt froskljós",
  "block.minecraft.peony": "Bóndarósa",
  "block.minecraft.petrified_oak_slab": "Steinrunnin eikipláta",
  "block.minecraft.piglin_head": "Piglinhøvd",
  "block.minecraft.piglin_wall_head": "Piglinvegghøvd",
  "block.minecraft.pink_banner": "Ljósareytt Flagg",
  "block.minecraft.pink_bed": "Ljósareyð Song",
  "block.minecraft.pink_candle": "Ljósareytt kertiljós",
  "block.minecraft.pink_candle_cake": "Kaka við ljósareyðum kertiljósi",
  "block.minecraft.pink_carpet": "Ljósareytt Teppi",
  "block.minecraft.pink_concrete": "Ljósareytt betong",
  "block.minecraft.pink_concrete_powder": "Ljósareytt betongpulvur",
  "block.minecraft.pink_glazed_terracotta": "Ljósareytt glasað terrakotta",
  "block.minecraft.pink_petals": "Ljósareyð krúnubløð",
  "block.minecraft.pink_shulker_box": "Ljósareyður shulkerkassi",
  "block.minecraft.pink_stained_glass": "Ljósareyðlitt glas",
  "block.minecraft.pink_stained_glass_pane": "Ljósareyðlittur rútur",
  "block.minecraft.pink_terracotta": "Ljósareytt terrakotta",
  "block.minecraft.pink_tulip": "Ljósareyð tulipan",
  "block.minecraft.pink_wool": "Ljósareyð ull",
  "block.minecraft.piston": "Stempul",
  "block.minecraft.piston_head": "Stempulhøvd",
  "block.minecraft.pitcher_crop": "Kannurótarskurður",
  "block.minecraft.pitcher_plant": "Kannurót",
  "block.minecraft.player_head": "Leikarahøvd",
  "block.minecraft.player_head.named": "Høvd á %s",
  "block.minecraft.player_wall_head": "Leikaravegghøvd",
  "block.minecraft.podzol": "Rakjørð",
  "block.minecraft.pointed_dripstone": "Dropasteinstubbi",
  "block.minecraft.polished_andesite": "Pussað andesitt",
  "block.minecraft.polished_andesite_slab": "Pussað andesittpláta",
  "block.minecraft.polished_andesite_stairs": "Pussað andesitttrappa",
  "block.minecraft.polished_basalt": "Pussað basalt",
  "block.minecraft.polished_blackstone": "Pussaður svartsteinur",
  "block.minecraft.polished_blackstone_brick_slab": "Pussað Svartsteinmúrsteinspláta",
  "block.minecraft.polished_blackstone_brick_stairs": "Pussað Svartsteinsmúrsteinstrappa",
  "block.minecraft.polished_blackstone_brick_wall": "Pussaður Svartsteinsmúrsteinsveggur",
  "block.minecraft.polished_blackstone_bricks": "Pussaðir Svartsteinsmúrsteinar",
  "block.minecraft.polished_blackstone_button": "Pussaður svartsteinsknøttur",
  "block.minecraft.polished_blackstone_pressure_plate": "Pussað Svartsteinstrýstpláta",
  "block.minecraft.polished_blackstone_slab": "Pussað svartsteinspláta",
  "block.minecraft.polished_blackstone_stairs": "Pussað svartsteinstrappa",
  "block.minecraft.polished_blackstone_wall": "Pussaður svartsteinsveggur",
  "block.minecraft.polished_deepslate": "Pussað djúphella",
  "block.minecraft.polished_deepslate_slab": "Pussað djúphellupláta",
  "block.minecraft.polished_deepslate_stairs": "Pussað djúphellutrappa",
  "block.minecraft.polished_deepslate_wall": "Pussaður djúphelluveggur",
  "block.minecraft.polished_diorite": "Pussað dioritt",
  "block.minecraft.polished_diorite_slab": "Pussað diorittpláta",
  "block.minecraft.polished_diorite_stairs": "Pussað dioritttrappa",
  "block.minecraft.polished_granite": "Pussað granitt",
  "block.minecraft.polished_granite_slab": "Pussað granittpláta",
  "block.minecraft.polished_granite_stairs": "Pussað granitttrappa",
  "block.minecraft.polished_tuff": "Pussað royðugrót",
  "block.minecraft.polished_tuff_slab": "Pussað royðupláta",
  "block.minecraft.polished_tuff_stairs": "Polished Tuff Stairs",
  "block.minecraft.polished_tuff_wall": "Pussaður royðuveggur",
  "block.minecraft.poppy": "Valmua",
  "block.minecraft.potatoes": "Epli",
  "block.minecraft.potted_acacia_sapling": "Akasiuspíri í potti",
  "block.minecraft.potted_allium": "Blómuleykur í potti",
  "block.minecraft.potted_azalea_bush": "Asalea í potti",
  "block.minecraft.potted_azure_bluet": "Eingjarkarsi í potti",
  "block.minecraft.potted_bamboo": "Bambus í potti",
  "block.minecraft.potted_birch_sapling": "Bjarkarspíri í potti",
  "block.minecraft.potted_blue_orchid": "Blá orkide í potti",
  "block.minecraft.potted_brown_mushroom": "Brúnur soppur í potti",
  "block.minecraft.potted_cactus": "Kaktus í potti",
  "block.minecraft.potted_cherry_sapling": "Kirsuberjaspíri í potti",
  "block.minecraft.potted_closed_eyeblossom": "Afturlatin eygablóma í potti",
  "block.minecraft.potted_cornflower": "Kornblóma í potti",
  "block.minecraft.potted_crimson_fungus": "Roðasoppur í potti",
  "block.minecraft.potted_crimson_roots": "Roðarøtur í potti",
  "block.minecraft.potted_dandelion": "Hagasólja í potti",
  "block.minecraft.potted_dark_oak_sapling": "Myrkur eikispíri í potti",
  "block.minecraft.potted_dead_bush": "Deyður runnur í potti",
  "block.minecraft.potted_fern": "Trøllakampur í potti",
  "block.minecraft.potted_flowering_azalea_bush": "Blómandi asalea í potti",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Frúmskógarspíri í potti",
  "block.minecraft.potted_lily_of_the_valley": "Dalalilja í potti",
  "block.minecraft.potted_mangrove_propagule": "Mangrovunøringarkorn í potti",
  "block.minecraft.potted_oak_sapling": "Eikispíri í potti",
  "block.minecraft.potted_open_eyeblossom": "Opin eygablóma í potti",
  "block.minecraft.potted_orange_tulip": "Appilsingul tulipan í potti",
  "block.minecraft.potted_oxeye_daisy": "Margaritt í potti",
  "block.minecraft.potted_pale_oak_sapling": "Bleikur eikispíri í potti",
  "block.minecraft.potted_pink_tulip": "Ljósareyð tulipan í potti",
  "block.minecraft.potted_poppy": "Dreymsólja í potti",
  "block.minecraft.potted_red_mushroom": "Reyður soppur í potti",
  "block.minecraft.potted_red_tulip": "Reyð tulipan í potti",
  "block.minecraft.potted_spruce_sapling": "Grannspíri í potti",
  "block.minecraft.potted_torchflower": "Kyndilsblóma í potti",
  "block.minecraft.potted_warped_fungus": "Tryglusoppur í potti",
  "block.minecraft.potted_warped_roots": "Tryglurøtur í potti",
  "block.minecraft.potted_white_tulip": "Hvít tulipan í potti",
  "block.minecraft.potted_wither_rose": "Witherrósa í potti",
  "block.minecraft.powder_snow": "Mjøll",
  "block.minecraft.powder_snow_cauldron": "Kavakar",
  "block.minecraft.powered_rail": "Elskinnari",
  "block.minecraft.prismarine": "Prismarin",
  "block.minecraft.prismarine_brick_slab": "Prismarinmúrsteinspláta",
  "block.minecraft.prismarine_brick_stairs": "Prismarinmúrsteinstrappa",
  "block.minecraft.prismarine_bricks": "Prismarinmúrsteinar",
  "block.minecraft.prismarine_slab": "Prismarinpláta",
  "block.minecraft.prismarine_stairs": "Prismarintrappa",
  "block.minecraft.prismarine_wall": "Prismarinveggur",
  "block.minecraft.pumpkin": "Grasker",
  "block.minecraft.pumpkin_stem": "Graskerjastelkur",
  "block.minecraft.purple_banner": "Lilla Flagg",
  "block.minecraft.purple_bed": "Lilla Song",
  "block.minecraft.purple_candle": "Lilla kertiljós",
  "block.minecraft.purple_candle_cake": "Kaka við lillaðum kertiljósi",
  "block.minecraft.purple_carpet": "Lilla Teppi",
  "block.minecraft.purple_concrete": "Lilla betong",
  "block.minecraft.purple_concrete_powder": "Lilla betongpulvur",
  "block.minecraft.purple_glazed_terracotta": "Lilla glasað terrakotta",
  "block.minecraft.purple_shulker_box": "Lillaður shulkerkassi",
  "block.minecraft.purple_stained_glass": "Lillalitt glas",
  "block.minecraft.purple_stained_glass_pane": "Lillalittur rútur",
  "block.minecraft.purple_terracotta": "Lilla terrakotta",
  "block.minecraft.purple_wool": "Lilla ull",
  "block.minecraft.purpur_block": "Purpurkubbi",
  "block.minecraft.purpur_pillar": "Purpursúla",
  "block.minecraft.purpur_slab": "Purpurpláta",
  "block.minecraft.purpur_stairs": "Purpurtrappa",
  "block.minecraft.quartz_block": "Kvartskubbi",
  "block.minecraft.quartz_bricks": "Kvartsmúrsteinar",
  "block.minecraft.quartz_pillar": "Kvartssúla",
  "block.minecraft.quartz_slab": "Kvartspláta",
  "block.minecraft.quartz_stairs": "Kvartstrappa",
  "block.minecraft.rail": "Skinnari",
  "block.minecraft.raw_copper_block": "Rákoparkubbi",
  "block.minecraft.raw_gold_block": "Rágulskubbi",
  "block.minecraft.raw_iron_block": "Rájarnskubbi",
  "block.minecraft.red_banner": "Reytt Flagg",
  "block.minecraft.red_bed": "Reyð Song",
  "block.minecraft.red_candle": "Reytt kertiljós",
  "block.minecraft.red_candle_cake": "Kaka við reyðum kertiljósi",
  "block.minecraft.red_carpet": "Reytt Teppi",
  "block.minecraft.red_concrete": "Reytt betong",
  "block.minecraft.red_concrete_powder": "Reytt betongpulvur",
  "block.minecraft.red_glazed_terracotta": "Reytt glasað terrakotta",
  "block.minecraft.red_mushroom": "Reyður soppur",
  "block.minecraft.red_mushroom_block": "Reyður soppakubbi",
  "block.minecraft.red_nether_brick_slab": "Reyð nethermúrsteinspláta",
  "block.minecraft.red_nether_brick_stairs": "Reyð nethermúrsteinstrappa",
  "block.minecraft.red_nether_brick_wall": "Reyður nethermúrsteinsveggur",
  "block.minecraft.red_nether_bricks": "Reyðir nethermúrsteinar",
  "block.minecraft.red_sand": "Reyðsendi",
  "block.minecraft.red_sandstone": "Reyðsandsteinur",
  "block.minecraft.red_sandstone_slab": "Reyðsandsteinspláta",
  "block.minecraft.red_sandstone_stairs": "Reyðsandsteinstrappa",
  "block.minecraft.red_sandstone_wall": "Reyðsandsteinsveggur",
  "block.minecraft.red_shulker_box": "Reyður shulkerkassi",
  "block.minecraft.red_stained_glass": "Reyðlitt glas",
  "block.minecraft.red_stained_glass_pane": "Reyðlittur rútur",
  "block.minecraft.red_terracotta": "Reytt terrakotta",
  "block.minecraft.red_tulip": "Reyð tulipan",
  "block.minecraft.red_wool": "Reyð ull",
  "block.minecraft.redstone_block": "Reyðgrýtiskubbi",
  "block.minecraft.redstone_lamp": "Reyðgrýtislampa",
  "block.minecraft.redstone_ore": "Reyðgrýtismálmur",
  "block.minecraft.redstone_torch": "Redstonekyndil",
  "block.minecraft.redstone_wall_torch": "Reyðgrýtisveggjakyndil",
  "block.minecraft.redstone_wire": "Reyðgrýtiskaðal",
  "block.minecraft.reinforced_deepslate": "Styrkt Djúphella",
  "block.minecraft.repeater": "Reyðgrýtisendurtakari",
  "block.minecraft.repeating_command_block": "Endurtakandi stýriboðskubbi",
  "block.minecraft.resin_block": "Harpeiskubbi",
  "block.minecraft.resin_brick_slab": "Harpeismúrsteinspláta",
  "block.minecraft.resin_brick_stairs": "Harpeismúrsteinstrappa",
  "block.minecraft.resin_brick_wall": "Harpeismúrsteinsveggur",
  "block.minecraft.resin_bricks": "Harpeismúrsteinar",
  "block.minecraft.resin_clump": "Harpeisklumpur",
  "block.minecraft.respawn_anchor": "Endurreisingarakker",
  "block.minecraft.rooted_dirt": "Rótgrógvin mold",
  "block.minecraft.rose_bush": "Rósurunnur",
  "block.minecraft.sand": "Sandur",
  "block.minecraft.sandstone": "Sandsteinur",
  "block.minecraft.sandstone_slab": "Sandsteinspláta",
  "block.minecraft.sandstone_stairs": "Sandsteinstrappa",
  "block.minecraft.sandstone_wall": "Sandsteinsveggur",
  "block.minecraft.scaffolding": "Arbeiðspallur",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculkkveiki",
  "block.minecraft.sculk_sensor": "Sculkvarnari",
  "block.minecraft.sculk_shrieker": "Sculkskrálari",
  "block.minecraft.sculk_vein": "Sculkæðr",
  "block.minecraft.sea_lantern": "Sjólykt",
  "block.minecraft.sea_pickle": "Sjóagurka",
  "block.minecraft.seagrass": "Sjógras",
  "block.minecraft.set_spawn": "Byrjanarstað sett",
  "block.minecraft.short_dry_grass": "Stutt turt gras",
  "block.minecraft.short_grass": "Stutt gras",
  "block.minecraft.shroomlight": "Soppaljós",
  "block.minecraft.shulker_box": "Shulkerkassi",
  "block.minecraft.skeleton_skull": "Skøltur",
  "block.minecraft.skeleton_wall_skull": "Veggjaskøltur",
  "block.minecraft.slime_block": "Slímkubbi",
  "block.minecraft.small_amethyst_bud": "Lítil ametystknubbi",
  "block.minecraft.small_dripleaf": "Lítið dropablað",
  "block.minecraft.smithing_table": "Smiðjuborð",
  "block.minecraft.smoker": "Roykjari",
  "block.minecraft.smooth_basalt": "Slætt basalt",
  "block.minecraft.smooth_quartz": "Sløtt kvartspláta",
  "block.minecraft.smooth_quartz_slab": "Sløtt kvartspláta",
  "block.minecraft.smooth_quartz_stairs": "Sløtt kvartstrappa",
  "block.minecraft.smooth_red_sandstone": "Slættur reyðsandsteinur",
  "block.minecraft.smooth_red_sandstone_slab": "Sløtt reyðsandsteinspláta",
  "block.minecraft.smooth_red_sandstone_stairs": "Sløtt reyðsandsteinstrappa",
  "block.minecraft.smooth_sandstone": "Slættur sandsteinur",
  "block.minecraft.smooth_sandstone_slab": "Sløtt sandsteinspláta",
  "block.minecraft.smooth_sandstone_stairs": "Sløtt sandsteinstrappa",
  "block.minecraft.smooth_stone": "Slættur Steinur",
  "block.minecraft.smooth_stone_slab": "Sløtt steinpláta",
  "block.minecraft.sniffer_egg": "Snoddaraegg",
  "block.minecraft.snow": "Kavi",
  "block.minecraft.snow_block": "Kavakubbi",
  "block.minecraft.soul_campfire": "Sálarbál",
  "block.minecraft.soul_fire": "Sálareldur",
  "block.minecraft.soul_lantern": "Sálarlykt",
  "block.minecraft.soul_sand": "Sálarsandur",
  "block.minecraft.soul_soil": "Sálarmold",
  "block.minecraft.soul_torch": "Sálarkyndil",
  "block.minecraft.soul_wall_torch": "Veggjasálarkyndil",
  "block.minecraft.spawn.not_valid": "Tú hevur hvørki heimsong ella løðað endurreisingarakker, um ikki tey vóru forðaði",
  "block.minecraft.spawner": "Skrímslakveikjari",
  "block.minecraft.spawner.desc1": "Nýt framkallingaregg:",
  "block.minecraft.spawner.desc2": "Setur veruslag",
  "block.minecraft.sponge": "Svampur",
  "block.minecraft.spore_blossom": "Gróblóma",
  "block.minecraft.spruce_button": "Grannknøttur",
  "block.minecraft.spruce_door": "Grannhurð",
  "block.minecraft.spruce_fence": "Granngirðing",
  "block.minecraft.spruce_fence_gate": "Granngrind",
  "block.minecraft.spruce_hanging_sign": "Hangandi grannskelti",
  "block.minecraft.spruce_leaves": "Grannnálir",
  "block.minecraft.spruce_log": "Grannstokkur",
  "block.minecraft.spruce_planks": "Grannviður",
  "block.minecraft.spruce_pressure_plate": "Granntrýstpláta",
  "block.minecraft.spruce_sapling": "Grannspíri",
  "block.minecraft.spruce_shelf": "Grannhill",
  "block.minecraft.spruce_sign": "Grannskelti",
  "block.minecraft.spruce_slab": "Grannpláta",
  "block.minecraft.spruce_stairs": "Granntrappa",
  "block.minecraft.spruce_trapdoor": "Grannlemmur",
  "block.minecraft.spruce_wall_hanging_sign": "Hangandi grannveggskelti",
  "block.minecraft.spruce_wall_sign": "Grannveggskelti",
  "block.minecraft.spruce_wood": "Granntræ",
  "block.minecraft.sticky_piston": "Klebrut stempul",
  "block.minecraft.stone": "Steinur",
  "block.minecraft.stone_brick_slab": "Steinmúrsteinspláta",
  "block.minecraft.stone_brick_stairs": "Steinmúrsteinstrappa",
  "block.minecraft.stone_brick_wall": "Steinmúrsteinsveggur",
  "block.minecraft.stone_bricks": "Steinmúrsteinar",
  "block.minecraft.stone_button": "Steinknøttur",
  "block.minecraft.stone_pressure_plate": "Steintrýstpláta",
  "block.minecraft.stone_slab": "Steinpláta",
  "block.minecraft.stone_stairs": "Steintrappa",
  "block.minecraft.stonecutter": "Steinskeri",
  "block.minecraft.stripped_acacia_log": "Avbarkaður akasiustokkur",
  "block.minecraft.stripped_acacia_wood": "Avbarkað akasiutræ",
  "block.minecraft.stripped_bamboo_block": "Avbarkaður bambuskubbi",
  "block.minecraft.stripped_birch_log": "Avbarkaður bjarkarstokkur",
  "block.minecraft.stripped_birch_wood": "Avbarkað bjarkartræ",
  "block.minecraft.stripped_cherry_log": "Avbarkaður kirsuberjastokkur",
  "block.minecraft.stripped_cherry_wood": "Avbarkað kirsuberjatræ",
  "block.minecraft.stripped_crimson_hyphae": "Skavaðir roðasoppatræðrir",
  "block.minecraft.stripped_crimson_stem": "Skavaður roðastelkur",
  "block.minecraft.stripped_dark_oak_log": "Avbarkaður myrkur eikistokkur",
  "block.minecraft.stripped_dark_oak_wood": "Avbarkað myrkt eikitræ",
  "block.minecraft.stripped_jungle_log": "Avbarkaður frumskógarstokkur",
  "block.minecraft.stripped_jungle_wood": "Avbarkað frumskógartræ",
  "block.minecraft.stripped_mangrove_log": "Avbarkaður mangrovustokkur",
  "block.minecraft.stripped_mangrove_wood": "Avbarkað mangrovutræ",
  "block.minecraft.stripped_oak_log": "Avbarkaður eikistokkur",
  "block.minecraft.stripped_oak_wood": "Avbarkað eikitræ",
  "block.minecraft.stripped_pale_oak_log": "Avbarkaður bleikur eikistokkur",
  "block.minecraft.stripped_pale_oak_wood": "Avbarkað bleikt eikitræ",
  "block.minecraft.stripped_spruce_log": "Avbarkaður grannstokkur",
  "block.minecraft.stripped_spruce_wood": "Avbarkað granntræ",
  "block.minecraft.stripped_warped_hyphae": "Skavaðir tryglusoppatræðrir",
  "block.minecraft.stripped_warped_stem": "Skavaður tryglustelkur",
  "block.minecraft.structure_block": "Byggingarkubbi",
  "block.minecraft.structure_void": "Tómrúmsstrukturur",
  "block.minecraft.sugar_cane": "Sukurrør",
  "block.minecraft.sunflower": "Sólblóma",
  "block.minecraft.suspicious_gravel": "Illgrunasamur eyrur",
  "block.minecraft.suspicious_sand": "Illgrunasamur sandur",
  "block.minecraft.sweet_berry_bush": "Søtberjarunnur",
  "block.minecraft.tall_dry_grass": "Høgt turt gras",
  "block.minecraft.tall_grass": "Høgt gras",
  "block.minecraft.tall_seagrass": "Høgt sjógras",
  "block.minecraft.target": "Skotskiva",
  "block.minecraft.terracotta": "Terrakotta",
  "block.minecraft.test_block": "Royndarkubbi",
  "block.minecraft.test_instance_block": "Test Instance Block",
  "block.minecraft.tinted_glass": "Tónað glas",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Sløkt er fyri TNT-spreingingum",
  "block.minecraft.torch": "Kyndil",
  "block.minecraft.torchflower": "Kyndilsblóma",
  "block.minecraft.torchflower_crop": "Kyndilsblómuurt",
  "block.minecraft.trapped_chest": "Fellukista",
  "block.minecraft.trial_spawner": "Próvkveikjari",
  "block.minecraft.tripwire": "Snávingartráður",
  "block.minecraft.tripwire_hook": "Snávingartráðskrókur",
  "block.minecraft.tube_coral": "Pípukorall",
  "block.minecraft.tube_coral_block": "Pípukorallkubbi",
  "block.minecraft.tube_coral_fan": "Pípukorallveiftra",
  "block.minecraft.tube_coral_wall_fan": "Pípukorallveggjaveiftra",
  "block.minecraft.tuff": "Royðugrót",
  "block.minecraft.tuff_brick_slab": "Royðumúrsteinspláta",
  "block.minecraft.tuff_brick_stairs": "Royðumúrsteinstrappa",
  "block.minecraft.tuff_brick_wall": "Royðumúrsteinsveggur",
  "block.minecraft.tuff_bricks": "Royðumúrsteinar",
  "block.minecraft.tuff_slab": "Royðupláta",
  "block.minecraft.tuff_stairs": "Royðutrappa",
  "block.minecraft.tuff_wall": "Royðuveggur",
  "block.minecraft.turtle_egg": "Skjaldbøkuegg",
  "block.minecraft.twisting_vines": "Snúðrandi klivurt",
  "block.minecraft.twisting_vines_plant": "Snúðrandi klivurt",
  "block.minecraft.vault": "Skrín",
  "block.minecraft.verdant_froglight": "Gróðurgrønt froskljós",
  "block.minecraft.vine": "Klivurt",
  "block.minecraft.void_air": "Tómrúmsluft",
  "block.minecraft.wall_torch": "Veggkyndil",
  "block.minecraft.warped_button": "Trygluknøttur",
  "block.minecraft.warped_door": "Trygluhurð",
  "block.minecraft.warped_fence": "Tryglugirðing",
  "block.minecraft.warped_fence_gate": "Tryglugrind",
  "block.minecraft.warped_fungus": "Tryglusoppur",
  "block.minecraft.warped_hanging_sign": "Hangandi trygluskelti",
  "block.minecraft.warped_hyphae": "Tryglusoppatræðrir",
  "block.minecraft.warped_nylium": "Tryglunoppavevnaður",
  "block.minecraft.warped_planks": "Trygluviður",
  "block.minecraft.warped_pressure_plate": "Tryglutrýstpláta",
  "block.minecraft.warped_roots": "Tryglurøtur",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "Trygluskelti",
  "block.minecraft.warped_slab": "Tryglupláta",
  "block.minecraft.warped_stairs": "Tryglutrappa",
  "block.minecraft.warped_stem": "Tryglustelkur",
  "block.minecraft.warped_trapdoor": "Tryglulemmur",
  "block.minecraft.warped_wall_hanging_sign": "Hangandi trygluskelti",
  "block.minecraft.warped_wall_sign": "Trygluskelti",
  "block.minecraft.warped_wart_block": "Tryglunetherfinnukubbi",
  "block.minecraft.water": "Vatn",
  "block.minecraft.water_cauldron": "Vatnkar",
  "block.minecraft.waxed_chiseled_copper": "Voksað meitlað kopar",
  "block.minecraft.waxed_copper_bars": "Voksaðar Koparstengur",
  "block.minecraft.waxed_copper_block": "Voksaður koparkubbi",
  "block.minecraft.waxed_copper_bulb": "Voksað koparlykt",
  "block.minecraft.waxed_copper_chain": "Voksað Koparketa",
  "block.minecraft.waxed_copper_chest": "Voksað Koparkista",
  "block.minecraft.waxed_copper_door": "Voksað koparhurð",
  "block.minecraft.waxed_copper_golem_statue": "Voksað Koparevnismennisstandmynd",
  "block.minecraft.waxed_copper_grate": "Voksað koparrist",
  "block.minecraft.waxed_copper_lantern": "Voksað Koparlykt",
  "block.minecraft.waxed_copper_trapdoor": "Voksaður koparlemmur",
  "block.minecraft.waxed_cut_copper": "Voksað skorið kopar",
  "block.minecraft.waxed_cut_copper_slab": "Voksað skorin koparpláta",
  "block.minecraft.waxed_cut_copper_stairs": "Voksað skorin kopartrappa",
  "block.minecraft.waxed_exposed_chiseled_copper": "Voksað Áfallið Meitlað Kopar",
  "block.minecraft.waxed_exposed_copper": "Voksað Áfallið Kopar",
  "block.minecraft.waxed_exposed_copper_bars": "Voksaðar Áfalnar Koparstengur",
  "block.minecraft.waxed_exposed_copper_bulb": "Voksað Áfallin Koparlykt",
  "block.minecraft.waxed_exposed_copper_chain": "Voksað Áfallin Koparketa",
  "block.minecraft.waxed_exposed_copper_chest": "Voksað Áfallin Koparkista",
  "block.minecraft.waxed_exposed_copper_door": "Voksað Áfallin koparhurð",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Voksað Áfallin Koparevnismennisstandmynd",
  "block.minecraft.waxed_exposed_copper_grate": "Voksað Áfallin koparrist",
  "block.minecraft.waxed_exposed_copper_lantern": "Voksað Áfallin Koparlykt",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Voksaður Áfallin Koparlemmur",
  "block.minecraft.waxed_exposed_cut_copper": "Voksað Áfallið Skorið Kopar",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Voksað Áfallin Skorin Koparpláta",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Voksað Áfallin Skorin Kopartrappa",
  "block.minecraft.waxed_exposed_lightning_rod": "Voksaður Áfallin Toruleiðari",
  "block.minecraft.waxed_lightning_rod": "Voksaður Toruleiðari",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Voksað súrevnað meitlað kopar",
  "block.minecraft.waxed_oxidized_copper": "Voksað súrevnað kopar",
  "block.minecraft.waxed_oxidized_copper_bars": "Voksaðar Eirgingnar Koparstengur",
  "block.minecraft.waxed_oxidized_copper_bulb": "Voksað súrevnað koparlykt",
  "block.minecraft.waxed_oxidized_copper_chain": "Voksað Eirgingin Koparketa",
  "block.minecraft.waxed_oxidized_copper_chest": "Voksað Eirgingin Koparkista",
  "block.minecraft.waxed_oxidized_copper_door": "Voksað súrevnað koparhurð",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Voksað Eirgingin Koparevnismennisstandmynd",
  "block.minecraft.waxed_oxidized_copper_grate": "Voksað súrevnað koparrist",
  "block.minecraft.waxed_oxidized_copper_lantern": "Voksað Eirgingin Lykt",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Voksaður súrevnaður koparlemmur",
  "block.minecraft.waxed_oxidized_cut_copper": "Voksað súrevnað skorið kopar",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Voksað súrevnað skorin koparpláta",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Voksað súrevnað skorin kopartrappa",
  "block.minecraft.waxed_oxidized_lightning_rod": "Voksaður Eirgingin Kopartoruleiðari",
  "block.minecraft.waxed_weathered_chiseled_copper": "Voksað veðurbart meitlað kopar",
  "block.minecraft.waxed_weathered_copper": "Voksað veðurbart kopar",
  "block.minecraft.waxed_weathered_copper_bars": "Voksaðar Eirdar Koparstengur",
  "block.minecraft.waxed_weathered_copper_bulb": "Voksað veðurbard koparlykt",
  "block.minecraft.waxed_weathered_copper_chain": "Voksað Eird Koparketa",
  "block.minecraft.waxed_weathered_copper_chest": "Voksað Eird Koparkista",
  "block.minecraft.waxed_weathered_copper_door": "Waxed Weathered Copper Door",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Voksað Eird Koparevnismennisstandmynd",
  "block.minecraft.waxed_weathered_copper_grate": "Voksað veðurbard koparrist",
  "block.minecraft.waxed_weathered_copper_lantern": "Voksað Eird Koparlykt",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Voksaður veðurbardur koparlemmur",
  "block.minecraft.waxed_weathered_cut_copper": "Voksa veðurbart skorið kopar",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Voksað veðurbard skorin koparpláta",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Voksað veðurbard skornin kopartrappa",
  "block.minecraft.waxed_weathered_lightning_rod": "Voksaður Eirdur Toruleiðari",
  "block.minecraft.weathered_chiseled_copper": "Veðurbart meitlað kopar",
  "block.minecraft.weathered_copper": "Veðurbart kopar",
  "block.minecraft.weathered_copper_bars": "Eirdar Koparstengur",
  "block.minecraft.weathered_copper_bulb": "Veðurbard koparlykt",
  "block.minecraft.weathered_copper_chain": "Voksað Eird Koparketa",
  "block.minecraft.weathered_copper_chest": "Eird Koparkista",
  "block.minecraft.weathered_copper_door": "Veðurbard koparhurð",
  "block.minecraft.weathered_copper_golem_statue": "Eird Koparevnismennisstandmynd",
  "block.minecraft.weathered_copper_grate": "Veðurbard koparrist",
  "block.minecraft.weathered_copper_lantern": "Eird Koparlykt",
  "block.minecraft.weathered_copper_trapdoor": "Veðurbardur koparlemmur",
  "block.minecraft.weathered_cut_copper": "Veðurbart skorið kopar",
  "block.minecraft.weathered_cut_copper_slab": "Veðurbard skorin koparpláta",
  "block.minecraft.weathered_cut_copper_stairs": "Veðurbard skorin kopartrappa",
  "block.minecraft.weathered_lightning_rod": "Eirdur Toruleiðari",
  "block.minecraft.weeping_vines": "Grátandi klivurt",
  "block.minecraft.weeping_vines_plant": "Grátandi klivurt",
  "block.minecraft.wet_sponge": "Vátur svampur",
  "block.minecraft.wheat": "Hveitiskurður",
  "block.minecraft.white_banner": "Hvítt merki",
  "block.minecraft.white_bed": "Hvít Song",
  "block.minecraft.white_candle": "Hvítt kertiljós",
  "block.minecraft.white_candle_cake": "Kaka við hvítum kertiljósi",
  "block.minecraft.white_carpet": "Hvítt Teppi",
  "block.minecraft.white_concrete": "Hvítt betong",
  "block.minecraft.white_concrete_powder": "Hvítt betongpulvur",
  "block.minecraft.white_glazed_terracotta": "Hvítt glasað terrakotta",
  "block.minecraft.white_shulker_box": "Hvítur shulkerkassi",
  "block.minecraft.white_stained_glass": "Hvíttlitt glas",
  "block.minecraft.white_stained_glass_pane": "Hvíttlittur rútur",
  "block.minecraft.white_terracotta": "Hvítt terrakotta",
  "block.minecraft.white_tulip": "Hvít tulipan",
  "block.minecraft.white_wool": "Hvít ull",
  "block.minecraft.wildflowers": "Eingjarblómur",
  "block.minecraft.wither_rose": "Witherrósa",
  "block.minecraft.wither_skeleton_skull": "Witherskøltur",
  "block.minecraft.wither_skeleton_wall_skull": "Witherveggjaskøltur",
  "block.minecraft.yellow_banner": "Gult Flagg",
  "block.minecraft.yellow_bed": "Gul Song",
  "block.minecraft.yellow_candle": "Gult kertiljós",
  "block.minecraft.yellow_candle_cake": "Kaka við gugum kertiljósi",
  "block.minecraft.yellow_carpet": "Gult Teppi",
  "block.minecraft.yellow_concrete": "Gult betong",
  "block.minecraft.yellow_concrete_powder": "Gult betongpulvur",
  "block.minecraft.yellow_glazed_terracotta": "Gult glasað terrakotta",
  "block.minecraft.yellow_shulker_box": "Gulur shulkerkassi",
  "block.minecraft.yellow_stained_glass": "Gullitt glas",
  "block.minecraft.yellow_stained_glass_pane": "Gullittur rútur",
  "block.minecraft.yellow_terracotta": "Gult terrakotta",
  "block.minecraft.yellow_wool": "Gul ull",
  "block.minecraft.zombie_head": "Deydningarhøvd",
  "block.minecraft.zombie_wall_head": "Deydningarveggjahøvd",
  "item.minecraft.acacia_boat": "Akasiubátur",
  "item.minecraft.acacia_chest_boat": "Akasiubátur við kistu",
  "item.minecraft.allay_spawn_egg": "Framkallingaregg fyri lætta",
  "item.minecraft.amethyst_shard": "Ametyst flís",
  "item.minecraft.angler_pottery_shard": "Pottabrot av seiðabergi",
  "item.minecraft.angler_pottery_sherd": "Angler Pottery Sherd",
  "item.minecraft.apple": "Súrepli",
  "item.minecraft.archer_pottery_shard": "Pottabrot av ørvagarpi",
  "item.minecraft.archer_pottery_sherd": "Pottabrot av ørvagarpi",
  "item.minecraft.armadillo_scute": "Hornhylki frá brynjudjóri",
  "item.minecraft.armadillo_spawn_egg": "Framkallingaregg fyri brynjudjór",
  "item.minecraft.armor_stand": "Brynjuhaldari",
  "item.minecraft.arms_up_pottery_shard": "Pottabrot av hendum á lofti",
  "item.minecraft.arms_up_pottery_sherd": "Pottabrot av hendum á lofti",
  "item.minecraft.arrow": "Ørvur",
  "item.minecraft.axolotl_bucket": "Spann við aksolotl",
  "item.minecraft.axolotl_spawn_egg": "Framkallingaregg fyri aksolotl",
  "item.minecraft.baked_potato": "Bakað epli",
  "item.minecraft.bamboo_chest_raft": "Bambusflaki við kistu",
  "item.minecraft.bamboo_raft": "Bambusflaki",
  "item.minecraft.bat_spawn_egg": "Framkallingaregg fyri flogmús",
  "item.minecraft.bee_spawn_egg": "Framkallingaregg fyri býflugu",
  "item.minecraft.beef": "Rátt oksakjøt",
  "item.minecraft.beetroot": "Reyðrót",
  "item.minecraft.beetroot_seeds": "Reyðrótarfræ",
  "item.minecraft.beetroot_soup": "Reyðrótarsúpan",
  "item.minecraft.birch_boat": "Bjarkarbátur",
  "item.minecraft.birch_chest_boat": "Bjarkarbátur við kistu",
  "item.minecraft.black_bundle": "Svartur pjøki",
  "item.minecraft.black_dye": "Svart litevni",
  "item.minecraft.black_harness": "Black Harness",
  "item.minecraft.blade_pottery_shard": "Pottabrot av svørði",
  "item.minecraft.blade_pottery_sherd": "Pottabrot av svørði",
  "item.minecraft.blaze_powder": "Logapulvur",
  "item.minecraft.blaze_rod": "Logastavur",
  "item.minecraft.blaze_spawn_egg": "Framkallingaregg fyri loga",
  "item.minecraft.blue_bundle": "Bláur pjøki",
  "item.minecraft.blue_dye": "Blátt litevni",
  "item.minecraft.blue_egg": "Blátt egg",
  "item.minecraft.blue_harness": "Blue Harness",
  "item.minecraft.bogged_spawn_egg": "Framkallingaregg fyri mýrigrind",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smiðjusnið",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Snarljós Brynjuprýði",
  "item.minecraft.bone": "Bein",
  "item.minecraft.bone_meal": "Beinmjøl",
  "item.minecraft.book": "Bók",
  "item.minecraft.bordure_indented_banner_pattern": "Kantutt Rammað Flaggmynstur",
  "item.minecraft.bow": "Bogi",
  "item.minecraft.bowl": "Bolli",
  "item.minecraft.bread": "Breyð",
  "item.minecraft.breeze_rod": "Flogastavur",
  "item.minecraft.breeze_spawn_egg": "Framkallingaregg fyri floga",
  "item.minecraft.brewer_pottery_shard": "Pottabrot av bryggj",
  "item.minecraft.brewer_pottery_sherd": "Pottabrot av bryggj",
  "item.minecraft.brewing_stand": "Brewing Stand",
  "item.minecraft.brick": "Múrsteinur",
  "item.minecraft.brown_bundle": "Brúnur pjøki",
  "item.minecraft.brown_dye": "Brúnt litevni",
  "item.minecraft.brown_egg": "Brúnt egg",
  "item.minecraft.brown_harness": "Brown Harness",
  "item.minecraft.brush": "Bust",
  "item.minecraft.bucket": "Spann",
  "item.minecraft.bundle": "Pjøki",
  "item.minecraft.bundle.empty": "Tómur",
  "item.minecraft.bundle.empty.description": "Kann pjøka ein blandaðan stakka av lutum",
  "item.minecraft.bundle.full": "Fullur",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Pottabrot av loga",
  "item.minecraft.burn_pottery_sherd": "Pottabrot av loga",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Framkallingaregg fyri kamel",
  "item.minecraft.carrot": "Gularót",
  "item.minecraft.carrot_on_a_stick": "Gularót á pinni",
  "item.minecraft.cat_spawn_egg": "Framkallingaregg fyri kettu",
  "item.minecraft.cauldron": "Kar",
  "item.minecraft.cave_spider_spawn_egg": "Framkallingaregg fyri hellueiturkopp",
  "item.minecraft.chainmail_boots": "Ringbrynjustivlar",
  "item.minecraft.chainmail_chestplate": "Ringbrynja",
  "item.minecraft.chainmail_helmet": "Ringbrynjuhjálmur",
  "item.minecraft.chainmail_leggings": "Ringbrynjubrøkur",
  "item.minecraft.charcoal": "Trækol",
  "item.minecraft.cherry_boat": "Kirsuberjabátur",
  "item.minecraft.cherry_chest_boat": "Kirsuberjabátur við kistu",
  "item.minecraft.chest_minecart": "Námsvognur við kistu",
  "item.minecraft.chicken": "Rátt høsnakjøt",
  "item.minecraft.chicken_spawn_egg": "Framkallingaregg fyri hønu",
  "item.minecraft.chorus_fruit": "Kórfrukt",
  "item.minecraft.clay_ball": "Leirbóltur",
  "item.minecraft.clock": "Klokka",
  "item.minecraft.coal": "Kol",
  "item.minecraft.coast_armor_trim_smithing_template": "Smiðjusnið",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Strond Brynjuprýði",
  "item.minecraft.cocoa_beans": "Kakaobønir",
  "item.minecraft.cod": "Ráur toskur",
  "item.minecraft.cod_bucket": "Spann við toski",
  "item.minecraft.cod_spawn_egg": "Framkallingaregg fyri tosk",
  "item.minecraft.command_block_minecart": "Námsvognur við stýriboðskubba",
  "item.minecraft.compass": "Kumpass",
  "item.minecraft.cooked_beef": "Búffur",
  "item.minecraft.cooked_chicken": "Kókað høsnakjøt",
  "item.minecraft.cooked_cod": "Kókaður toskur",
  "item.minecraft.cooked_mutton": "Kókað lambskjøt",
  "item.minecraft.cooked_porkchop": "Kókað svínakotelett",
  "item.minecraft.cooked_rabbit": "Kókað kaninkjøt",
  "item.minecraft.cooked_salmon": "Kókaður laksur",
  "item.minecraft.cookie": "Smákøka",
  "item.minecraft.copper_axe": "Koparøks",
  "item.minecraft.copper_boots": "Koparstyvlar",
  "item.minecraft.copper_chestplate": "Koparbrynja",
  "item.minecraft.copper_golem_spawn_egg": "Koparmenni",
  "item.minecraft.copper_helmet": "Koparhjálmur",
  "item.minecraft.copper_hoe": "Koparlúkijarn",
  "item.minecraft.copper_horse_armor": "Koparrossabrynja",
  "item.minecraft.copper_ingot": "Koparstong",
  "item.minecraft.copper_leggings": "Koparleggverjar",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Koparklumpur",
  "item.minecraft.copper_pickaxe": "Koparhakkari",
  "item.minecraft.copper_shovel": "Koparspaki",
  "item.minecraft.copper_spear": "Koparspjót",
  "item.minecraft.copper_sword": "Koparsvørð",
  "item.minecraft.cow_spawn_egg": "Framkallingaregg fyri kúgv",
  "item.minecraft.creaking_spawn_egg": "Framkallingaregg fyri knarruna",
  "item.minecraft.creeper_banner_pattern": "Flaggmynstur",
  "item.minecraft.creeper_banner_pattern.desc": "Creepermynstur",
  "item.minecraft.creeper_banner_pattern.new": "Flaggmynstur av creeper",
  "item.minecraft.creeper_spawn_egg": "Framkallingaregg fyri creeper",
  "item.minecraft.crossbow": "Lásbogi",
  "item.minecraft.crossbow.projectile": "Skot:",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectile: %s",
  "item.minecraft.cyan_bundle": "Blágrønur pjøki",
  "item.minecraft.cyan_dye": "Blágrønt Litevni",
  "item.minecraft.cyan_harness": "Cyan Harness",
  "item.minecraft.danger_pottery_shard": "Pottabrot av vanda",
  "item.minecraft.danger_pottery_sherd": "Pottabrot av vanda",
  "item.minecraft.dark_oak_boat": "Myrkur eikibátur",
  "item.minecraft.dark_oak_chest_boat": "Myrkur eikibátur við kistu",
  "item.minecraft.debug_stick": "Villurfinningarpinnur",
  "item.minecraft.debug_stick.empty": "%s hevur ongar eginleikar",
  "item.minecraft.debug_stick.select": "valdi \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" til %s",
  "item.minecraft.diamond": "Diamantur",
  "item.minecraft.diamond_axe": "Diamantøks",
  "item.minecraft.diamond_boots": "Diamantstivlar",
  "item.minecraft.diamond_chestplate": "Diamantbrynja",
  "item.minecraft.diamond_helmet": "Diamanthjálmur",
  "item.minecraft.diamond_hoe": "Diamant-lúkijarn",
  "item.minecraft.diamond_horse_armor": "Diamantbrynja til Ross",
  "item.minecraft.diamond_leggings": "Diamantbrøkur",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Diamanthakkari",
  "item.minecraft.diamond_shovel": "Diamantspaki",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "Diamantsvørð",
  "item.minecraft.disc_fragment_5": "Fløgupetti",
  "item.minecraft.disc_fragment_5.desc": "Ljómfløga - 5",
  "item.minecraft.dolphin_spawn_egg": "Framkallingaregg fyri hvessing",
  "item.minecraft.donkey_spawn_egg": "Framkallingaregg fyri asna",
  "item.minecraft.dragon_breath": "Drekaandi",
  "item.minecraft.dried_kelp": "Turkaður tari",
  "item.minecraft.drowned_spawn_egg": "Framkallingaregg fyri dreyg",
  "item.minecraft.dune_armor_trim_smithing_template": "Smiðjusnið",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Sandfonn Brynjuprýði",
  "item.minecraft.echo_shard": "Ekkóskarð",
  "item.minecraft.egg": "Egg",
  "item.minecraft.elder_guardian_spawn_egg": "Framkallingaregg fyri eldraverja",
  "item.minecraft.elytra": "Verndarveingir",
  "item.minecraft.emerald": "Smaragdur",
  "item.minecraft.enchanted_book": "Rúnabók",
  "item.minecraft.enchanted_golden_apple": "Gandað gylt súrepli",
  "item.minecraft.end_crystal": "Endkrystall",
  "item.minecraft.ender_dragon_spawn_egg": "Framkallingaregg fyri enderdreka",
  "item.minecraft.ender_eye": "Endereyga",
  "item.minecraft.ender_pearl": "Enderperla",
  "item.minecraft.enderman_spawn_egg": "Framkallingaregg fyri endermann",
  "item.minecraft.endermite_spawn_egg": "Framkallingaregg fyri endermite",
  "item.minecraft.evoker_spawn_egg": "Framkallingaregg fyri vekjara",
  "item.minecraft.experience_bottle": "Gandafløska",
  "item.minecraft.explorer_pottery_shard": "Pottabrot av rannsakan",
  "item.minecraft.explorer_pottery_sherd": "Pottabrot av rannsakan",
  "item.minecraft.eye_armor_trim_smithing_template": "Smiðjusnið",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Eyga Brynjuprýði",
  "item.minecraft.feather": "Fjøður",
  "item.minecraft.fermented_spider_eye": "Ræst eiturkoppaeyga",
  "item.minecraft.field_masoned_banner_pattern": "Múrað Flaggmynstur",
  "item.minecraft.filled_map": "Kort",
  "item.minecraft.fire_charge": "Eldløðing",
  "item.minecraft.firework_rocket": "Fýrverksrakett",
  "item.minecraft.firework_rocket.flight": "Flogtíð:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Fýrverksstjørna",
  "item.minecraft.firework_star.black": "Svørt",
  "item.minecraft.firework_star.blue": "Blá",
  "item.minecraft.firework_star.brown": "Brún",
  "item.minecraft.firework_star.custom_color": "Custom",
  "item.minecraft.firework_star.cyan": "Blágrøn",
  "item.minecraft.firework_star.fade_to": "Fána til",
  "item.minecraft.firework_star.flicker": "Glógvan",
  "item.minecraft.firework_star.gray": "Grá",
  "item.minecraft.firework_star.green": "Grøn",
  "item.minecraft.firework_star.light_blue": "Ljósablá",
  "item.minecraft.firework_star.light_gray": "Ljósagrá",
  "item.minecraft.firework_star.lime": "Ljósagrønt",
  "item.minecraft.firework_star.magenta": "Viólreyð",
  "item.minecraft.firework_star.orange": "Appilsingul",
  "item.minecraft.firework_star.pink": "Ljósareyð",
  "item.minecraft.firework_star.purple": "Lilla",
  "item.minecraft.firework_star.red": "Reyð",
  "item.minecraft.firework_star.shape": "Ókendur formur",
  "item.minecraft.firework_star.shape.burst": "Spreinging",
  "item.minecraft.firework_star.shape.creeper": "Creeper-snið",
  "item.minecraft.firework_star.shape.large_ball": "Stórur bóltur",
  "item.minecraft.firework_star.shape.small_ball": "Lítil bóltur",
  "item.minecraft.firework_star.shape.star": "Stjørnuformað",
  "item.minecraft.firework_star.trail": "Slóð",
  "item.minecraft.firework_star.white": "Hvít",
  "item.minecraft.firework_star.yellow": "Gul",
  "item.minecraft.fishing_rod": "Tráða",
  "item.minecraft.flint": "Tinna",
  "item.minecraft.flint_and_steel": "Tinna og stál",
  "item.minecraft.flow_armor_trim_smithing_template": "Smiðjusnið",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Flóð Brynjuprýði",
  "item.minecraft.flow_banner_pattern": "Flaggmynstur",
  "item.minecraft.flow_banner_pattern.desc": "Flóð",
  "item.minecraft.flow_banner_pattern.new": "Flaggmynstur av Flóð",
  "item.minecraft.flow_pottery_sherd": "Pottabrot av flóð",
  "item.minecraft.flower_banner_pattern": "Flaggmynstur",
  "item.minecraft.flower_banner_pattern.desc": "Blómumynstur",
  "item.minecraft.flower_banner_pattern.new": "Flaggmynstur av Blómu",
  "item.minecraft.flower_pot": "Urtapottur",
  "item.minecraft.fox_spawn_egg": "Framkallingaregg fyri rev",
  "item.minecraft.friend_pottery_shard": "Pottabrot av vini",
  "item.minecraft.friend_pottery_sherd": "Pottabrot av vini",
  "item.minecraft.frog_spawn_egg": "Framkallingaregg fyri frosk",
  "item.minecraft.furnace_minecart": "Námsvognur við ovni",
  "item.minecraft.ghast_spawn_egg": "Framkallingaregg fyri ghast",
  "item.minecraft.ghast_tear": "Ghasttár",
  "item.minecraft.glass_bottle": "Glasfløska",
  "item.minecraft.glistering_melon_slice": "Glitrandi vatnmelónsflís",
  "item.minecraft.globe_banner_pattern": "Flaggmynstur",
  "item.minecraft.globe_banner_pattern.desc": "Knøttur",
  "item.minecraft.globe_banner_pattern.new": "Flaggmynstur av Knøtti",
  "item.minecraft.glow_berries": "Gløðiber",
  "item.minecraft.glow_ink_sac": "Gløðiblekkposi",
  "item.minecraft.glow_item_frame": "Gløðandi lutaramma",
  "item.minecraft.glow_squid_spawn_egg": "Framkallingaregg fyri gløðislokk",
  "item.minecraft.glowstone_dust": "Gløðisteinspulvur",
  "item.minecraft.goat_horn": "Geitahorn",
  "item.minecraft.goat_spawn_egg": "Framkallingaregg fyri geit",
  "item.minecraft.gold_ingot": "Gullstong",
  "item.minecraft.gold_nugget": "Gullklumpur",
  "item.minecraft.golden_apple": "Gylt Súrepli",
  "item.minecraft.golden_axe": "Gulløks",
  "item.minecraft.golden_boots": "Gullstivlar",
  "item.minecraft.golden_carrot": "Gullarót",
  "item.minecraft.golden_chestplate": "Gullbrynja",
  "item.minecraft.golden_helmet": "Gullhjálmur",
  "item.minecraft.golden_hoe": "Gull-lúkijarn",
  "item.minecraft.golden_horse_armor": "Gullbrynja til ross",
  "item.minecraft.golden_leggings": "Gullbrøkur",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Gullhakkari",
  "item.minecraft.golden_shovel": "Gullspaki",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "Gullsvørð",
  "item.minecraft.gray_bundle": "Gráur pjøki",
  "item.minecraft.gray_dye": "Grátt Litevni",
  "item.minecraft.gray_harness": "Gray Harness",
  "item.minecraft.green_bundle": "Grønur pjøki",
  "item.minecraft.green_dye": "Grønt litevni",
  "item.minecraft.green_harness": "Green Harness",
  "item.minecraft.guardian_spawn_egg": "Framkallingaregg fyri verja",
  "item.minecraft.gunpowder": "Krút",
  "item.minecraft.guster_banner_pattern": "Flaggmynstur",
  "item.minecraft.guster_banner_pattern.desc": "Flogi",
  "item.minecraft.guster_banner_pattern.new": "Flaggmynstur av Floga",
  "item.minecraft.guster_pottery_sherd": "Pottabrot av gjósti",
  "item.minecraft.happy_ghast_spawn_egg": "Happy Ghast Spawn Egg",
  "item.minecraft.harness": "Harness",
  "item.minecraft.heart_of_the_sea": "Havshjarta",
  "item.minecraft.heart_pottery_shard": "Pottabrot av hjarta",
  "item.minecraft.heart_pottery_sherd": "Pottabrot av hjarta",
  "item.minecraft.heartbreak_pottery_shard": "Pottabrot av hjartasorg",
  "item.minecraft.heartbreak_pottery_sherd": "Pottabrot av hjartasorg",
  "item.minecraft.hoglin_spawn_egg": "Framkallingaregg fyri Hoglin",
  "item.minecraft.honey_bottle": "Hunangsfløska",
  "item.minecraft.honeycomb": "Býflugukøka",
  "item.minecraft.hopper_minecart": "Námsvognur við trakt",
  "item.minecraft.horse_spawn_egg": "Framkallingaregg fyri ross",
  "item.minecraft.host_armor_trim_smithing_template": "Smiðjusnið",
  "item.minecraft.host_armor_trim_smithing_template.new": "Vertur Brynjuprýði",
  "item.minecraft.howl_pottery_shard": "Pottabrot av ýli",
  "item.minecraft.howl_pottery_sherd": "Pottabrot av ýli",
  "item.minecraft.husk_spawn_egg": "Framkallingaregg fyri øgn",
  "item.minecraft.ink_sac": "Blekkposi",
  "item.minecraft.iron_axe": "Jarnøks",
  "item.minecraft.iron_boots": "Jarnstivlar",
  "item.minecraft.iron_chestplate": "Jarnbrynja",
  "item.minecraft.iron_golem_spawn_egg": "Framkallingaregg fyri jarnmenni",
  "item.minecraft.iron_helmet": "Jarnhjálmur",
  "item.minecraft.iron_hoe": "Jarn-lúkijarn",
  "item.minecraft.iron_horse_armor": "Jarnbrynja til Ross",
  "item.minecraft.iron_ingot": "Jarnstong",
  "item.minecraft.iron_leggings": "Jarnbrøkur",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Jarnklumpur",
  "item.minecraft.iron_pickaxe": "Jarnhakkari",
  "item.minecraft.iron_shovel": "Jarnspaki",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "Jarnsvørð",
  "item.minecraft.item_frame": "Lutaramma",
  "item.minecraft.jungle_boat": "Frumskógarbátur",
  "item.minecraft.jungle_chest_boat": "Frumskógarbátur við kistu",
  "item.minecraft.knowledge_book": "Kunnleikabók",
  "item.minecraft.lapis_lazuli": "Asursteinur",
  "item.minecraft.lava_bucket": "Spann við gosi",
  "item.minecraft.lead": "Leiðingarband",
  "item.minecraft.leather": "Leður",
  "item.minecraft.leather_boots": "Leðurstivlar",
  "item.minecraft.leather_chestplate": "Leðurtroyggja",
  "item.minecraft.leather_helmet": "Leðurhúgva",
  "item.minecraft.leather_horse_armor": "Leðurrossabrynja",
  "item.minecraft.leather_leggings": "Leðurbrøkur",
  "item.minecraft.light_blue_bundle": "Ljósabláur pjøki",
  "item.minecraft.light_blue_dye": "Ljósablátt Litevni",
  "item.minecraft.light_blue_harness": "Light Blue Harness",
  "item.minecraft.light_gray_bundle": "Ljósagráur pjøki",
  "item.minecraft.light_gray_dye": "Ljósagrátt Litevni",
  "item.minecraft.light_gray_harness": "Light Gray Harness",
  "item.minecraft.lime_bundle": "Ljósagrønur pjøki",
  "item.minecraft.lime_dye": "Ljósagrønt litevni",
  "item.minecraft.lime_harness": "Lime Harness",
  "item.minecraft.lingering_potion": "Viðvarandi drykkur",
  "item.minecraft.lingering_potion.effect.awkward": "Klombrutur dvøljudrykkur",
  "item.minecraft.lingering_potion.effect.empty": "Óevniligur dvøljudrykkur",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Eldmótstøðudvøljudrykkur",
  "item.minecraft.lingering_potion.effect.harming": "Skaðandi dvøljudrykkur",
  "item.minecraft.lingering_potion.effect.healing": "Grøðandi dvøljudrykkur",
  "item.minecraft.lingering_potion.effect.infested": "Plágandi dvøljudrykkur",
  "item.minecraft.lingering_potion.effect.invisibility": "Ósjónleikadvøljudrykkur",
  "item.minecraft.lingering_potion.effect.leaping": "Risalopsdvøljudrykkur",
  "item.minecraft.lingering_potion.effect.levitation": "Sveimandi dvøljudrykkur",
  "item.minecraft.lingering_potion.effect.luck": "Eyðnudvøljudrykkur",
  "item.minecraft.lingering_potion.effect.mundane": "Turrisligur dvøljudrykkur",
  "item.minecraft.lingering_potion.effect.night_vision": "Náttarsjóndardvøljudrykkur",
  "item.minecraft.lingering_potion.effect.oozing": "Seyrandi dvøljudrykkur",
  "item.minecraft.lingering_potion.effect.poison": "Eitrandi dvøljudrykkur",
  "item.minecraft.lingering_potion.effect.regeneration": "Lekjandi dvøljudrykkur",
  "item.minecraft.lingering_potion.effect.slow_falling": "Fjaðrarfalsdvøljudrykkur",
  "item.minecraft.lingering_potion.effect.slowness": "Seinleikadvøljudrykkur",
  "item.minecraft.lingering_potion.effect.strength": "Styrkjandi dvøljudrykkur",
  "item.minecraft.lingering_potion.effect.swiftness": "Kvikleikadvøljudrykkur",
  "item.minecraft.lingering_potion.effect.thick": "Tjúkkur dvøljudrykkur",
  "item.minecraft.lingering_potion.effect.turtle_master": "Skjalbøkumeistaradvøljudrykkur",
  "item.minecraft.lingering_potion.effect.water": "Dvøljuvatnfløska",
  "item.minecraft.lingering_potion.effect.water_breathing": "Táknudvøljudrykkur",
  "item.minecraft.lingering_potion.effect.weakness": "Veikleikadvøljudrykkur",
  "item.minecraft.lingering_potion.effect.weaving": "Vevnadvøljudrykkur",
  "item.minecraft.lingering_potion.effect.wind_charged": "Vindløðandi dvøljudrykkur",
  "item.minecraft.llama_spawn_egg": "Framkallingaregg fyri lama",
  "item.minecraft.lodestone_compass": "Sigulsteinskumpass",
  "item.minecraft.mace": "Sleggja",
  "item.minecraft.magenta_bundle": "Viólreyður pjøki",
  "item.minecraft.magenta_dye": "Viólreytt litevni",
  "item.minecraft.magenta_harness": "Magenta Harness",
  "item.minecraft.magma_cream": "Magmakrem",
  "item.minecraft.magma_cube_spawn_egg": "Framkallingaregg fyri magmakubba",
  "item.minecraft.mangrove_boat": "Mangrovubátur",
  "item.minecraft.mangrove_chest_boat": "Mangrovubátur við kistu",
  "item.minecraft.map": "Tómt kort",
  "item.minecraft.melon_seeds": "Vatnmelónsfræ",
  "item.minecraft.melon_slice": "Vatnmelónsflís",
  "item.minecraft.milk_bucket": "Spann við mjólk",
  "item.minecraft.minecart": "Námsvognur",
  "item.minecraft.miner_pottery_shard": "Pottabrot av grevsti",
  "item.minecraft.miner_pottery_sherd": "Pottabrot av grevsti",
  "item.minecraft.mojang_banner_pattern": "Flaggmynstur",
  "item.minecraft.mojang_banner_pattern.desc": "Lutur",
  "item.minecraft.mojang_banner_pattern.new": "Flaggmynstur av Luti",
  "item.minecraft.mooshroom_spawn_egg": "Framkallingaregg fyri mooshroom",
  "item.minecraft.mourner_pottery_shard": "Pottabrot av sorg",
  "item.minecraft.mourner_pottery_sherd": "Pottabrot av sorg",
  "item.minecraft.mule_spawn_egg": "Framkallingaregg fyri múldýr",
  "item.minecraft.mushroom_stew": "Soppastúvningur",
  "item.minecraft.music_disc_11": "Ljómfløga",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Ljómfløga",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Ljómfløga",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Ljómfløga",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Ljómfløga",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Music Disc",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Ljómfløga",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Ljómfløga",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Ljómfløga",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Music Disc",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Ljómfløga",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Ljómfløga",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Ljómfløga",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Ljómfløga",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Ljómfløga",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Ljómfløga",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Ljómfløga",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Ljómfløga",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Music Disc",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Ljómfløga",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Ljómfløga",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Rátt lamb",
  "item.minecraft.name_tag": "Navnaskelti",
  "item.minecraft.nautilus_shell": "Skiparaskeljaskel",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "Nethermúrsteinur",
  "item.minecraft.nether_star": "Netherstjørna",
  "item.minecraft.nether_wart": "Netherfinna",
  "item.minecraft.netherite_axe": "Netherittøks",
  "item.minecraft.netherite_boots": "Netherittstivlar",
  "item.minecraft.netherite_chestplate": "Netherittbrynja",
  "item.minecraft.netherite_helmet": "Netheritthjálmur",
  "item.minecraft.netherite_hoe": "Netherittlúkijarn",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "Netherittstong",
  "item.minecraft.netherite_leggings": "Netherittbrøkur",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Netheritthakkari",
  "item.minecraft.netherite_scrap": "Netherittfras",
  "item.minecraft.netherite_shovel": "Netherittspaki",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "Netherittsvørð",
  "item.minecraft.netherite_upgrade_smithing_template": "Smiðjusnið",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherittábót",
  "item.minecraft.oak_boat": "Eikibátur",
  "item.minecraft.oak_chest_boat": "Eikibátur við kistu",
  "item.minecraft.ocelot_spawn_egg": "Framkallingaregg fyri villkøtt",
  "item.minecraft.ominous_bottle": "Ominous Bottle",
  "item.minecraft.ominous_trial_key": "Illboðandi próvlykil",
  "item.minecraft.orange_bundle": "Appilsingulur pjøki",
  "item.minecraft.orange_dye": "Appilsingult litevni",
  "item.minecraft.orange_harness": "Orange Harness",
  "item.minecraft.painting": "Málarí",
  "item.minecraft.pale_oak_boat": "Bleikur eikibátur",
  "item.minecraft.pale_oak_chest_boat": "Bleikur eikibátur við kistu",
  "item.minecraft.panda_spawn_egg": "Framkallingaregg fyri pandu",
  "item.minecraft.paper": "Pappír",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Framkallingaregg fyri pappageyk",
  "item.minecraft.phantom_membrane": "Dregilshinna",
  "item.minecraft.phantom_spawn_egg": "Framkallingaregg fyri dregil",
  "item.minecraft.pig_spawn_egg": "Framkallingaregg fyri grís",
  "item.minecraft.piglin_banner_pattern": "Flaggmynstur",
  "item.minecraft.piglin_banner_pattern.desc": "Snúti",
  "item.minecraft.piglin_banner_pattern.new": "Flaggmynstur av snúti",
  "item.minecraft.piglin_brute_spawn_egg": "Framkallingaregg fyri piglinbøðil",
  "item.minecraft.piglin_spawn_egg": "Framkallingaregg fyri piglin",
  "item.minecraft.pillager_spawn_egg": "Framkallingaregg fyri rænara",
  "item.minecraft.pink_bundle": "Ljósareyður pjøki",
  "item.minecraft.pink_dye": "Ljósareytt Litevni",
  "item.minecraft.pink_harness": "Pink Harness",
  "item.minecraft.pitcher_plant": "Pitcher Plant",
  "item.minecraft.pitcher_pod": "Pitcher Pod",
  "item.minecraft.plenty_pottery_shard": "Pottabrot av ríkidømi",
  "item.minecraft.plenty_pottery_sherd": "Pottabrot av ríkidømi",
  "item.minecraft.poisonous_potato": "Eitrað epli",
  "item.minecraft.polar_bear_spawn_egg": "Framkallingaregg fyri hvítabjørn",
  "item.minecraft.popped_chorus_fruit": "Brostin kórfrúkt",
  "item.minecraft.porkchop": "Rá svínakotelett",
  "item.minecraft.potato": "Epli",
  "item.minecraft.potion": "Drykkur",
  "item.minecraft.potion.effect.awkward": "Klombrutur drykkur",
  "item.minecraft.potion.effect.empty": "Óevniligur drykkur",
  "item.minecraft.potion.effect.fire_resistance": "Eldmótstøðudrykkur",
  "item.minecraft.potion.effect.harming": "Skaðandi drykkur",
  "item.minecraft.potion.effect.healing": "Grøðandi drykkur",
  "item.minecraft.potion.effect.infested": "Plágandi drykkur",
  "item.minecraft.potion.effect.invisibility": "Ósjónleikadrykkur",
  "item.minecraft.potion.effect.leaping": "Risalopsdrykkur",
  "item.minecraft.potion.effect.levitation": "Sveimidrykkur",
  "item.minecraft.potion.effect.luck": "Eydnudrykkur",
  "item.minecraft.potion.effect.mundane": "Turrisligur drykkur",
  "item.minecraft.potion.effect.night_vision": "Náttarsjóndardrykkur",
  "item.minecraft.potion.effect.oozing": "Seyrandi drykkur",
  "item.minecraft.potion.effect.poison": "Eitrandi drykkur",
  "item.minecraft.potion.effect.regeneration": "Lekjandi drykkur",
  "item.minecraft.potion.effect.slow_falling": "Fjaðrarfalsdrykkur",
  "item.minecraft.potion.effect.slowness": "Seinleikadrykkur",
  "item.minecraft.potion.effect.strength": "Styrkjandi drykkur",
  "item.minecraft.potion.effect.swiftness": "Kvikleikadrykkur",
  "item.minecraft.potion.effect.thick": "Tjúkkur drykkur",
  "item.minecraft.potion.effect.turtle_master": "Skjaldbøkumeistaradrykkur",
  "item.minecraft.potion.effect.water": "Vatnfløska",
  "item.minecraft.potion.effect.water_breathing": "Táknardrykkur",
  "item.minecraft.potion.effect.weakness": "Veikleikadrykkur",
  "item.minecraft.potion.effect.weaving": "Vevnadrykkur",
  "item.minecraft.potion.effect.wind_charged": "Vindløðandi drykkur",
  "item.minecraft.pottery_shard_archer": "Pottabrot av ørvagarpi",
  "item.minecraft.pottery_shard_arms_up": "Pottabrot av hendum á lofti",
  "item.minecraft.pottery_shard_prize": "Pottabrot av dýrgripi",
  "item.minecraft.pottery_shard_skull": "Pottabrot av skølti",
  "item.minecraft.powder_snow_bucket": "Spann við kava",
  "item.minecraft.prismarine_crystals": "Prismarinkrystallir",
  "item.minecraft.prismarine_shard": "Prismarinbrot",
  "item.minecraft.prize_pottery_shard": "Pottabrot av dýrgripi",
  "item.minecraft.prize_pottery_sherd": "Pottabrot av dýrgripi",
  "item.minecraft.pufferfish": "Ígulfiskur",
  "item.minecraft.pufferfish_bucket": "Spann við ígulfiski",
  "item.minecraft.pufferfish_spawn_egg": "Framkallingaregg fyri ígulfisk",
  "item.minecraft.pumpkin_pie": "Graskerjaterta",
  "item.minecraft.pumpkin_seeds": "Graskerjafræ",
  "item.minecraft.purple_bundle": "Lillaður pjøki",
  "item.minecraft.purple_dye": "Lilla Litevni",
  "item.minecraft.purple_harness": "Purple Harness",
  "item.minecraft.quartz": "Netherkvarts",
  "item.minecraft.rabbit": "Rá kanin",
  "item.minecraft.rabbit_foot": "Kaninfótur",
  "item.minecraft.rabbit_hide": "Kaninskinn",
  "item.minecraft.rabbit_spawn_egg": "Framkallingaregg fyri kanin",
  "item.minecraft.rabbit_stew": "Kaninsúpan",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smiðjusnið",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Reisari Brynjuprýði",
  "item.minecraft.ravager_spawn_egg": "Framkallingaregg fyri herjara",
  "item.minecraft.raw_copper": "Rátt kopar",
  "item.minecraft.raw_gold": "Rátt gull",
  "item.minecraft.raw_iron": "Rátt jarn",
  "item.minecraft.recovery_compass": "Afturfinningarkumpass",
  "item.minecraft.red_bundle": "Reyður pjøki",
  "item.minecraft.red_dye": "Reytt litevni",
  "item.minecraft.red_harness": "Red Harness",
  "item.minecraft.redstone": "Reyðgrýtisdust",
  "item.minecraft.resin_brick": "Harpeismúrsteinur",
  "item.minecraft.resin_clump": "Harpeisklumpur",
  "item.minecraft.rib_armor_trim_smithing_template": "Smiðjusnið",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Riv Brynjuprýði",
  "item.minecraft.rotten_flesh": "Rotið kjøt",
  "item.minecraft.saddle": "Saðil",
  "item.minecraft.salmon": "Ráur laksur",
  "item.minecraft.salmon_bucket": "Spann við laksi",
  "item.minecraft.salmon_spawn_egg": "Framkallingaregg fyri laks",
  "item.minecraft.scrape_pottery_sherd": "Pottabrot av skavan",
  "item.minecraft.scute": "Hornhylki",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smiðjusnið",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Vakt Brynjuprýði",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smiðjusnið",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Sniðgevi Brynjuprýði",
  "item.minecraft.sheaf_pottery_shard": "Pottabrot av bundi",
  "item.minecraft.sheaf_pottery_sherd": "Pottabrot av bundi",
  "item.minecraft.shears": "Saksur",
  "item.minecraft.sheep_spawn_egg": "Framkallingaregg fyri seyð",
  "item.minecraft.shelter_pottery_shard": "Pottabrot av skýli",
  "item.minecraft.shelter_pottery_sherd": "Pottabrot av skýli",
  "item.minecraft.shield": "Skjøldur",
  "item.minecraft.shield.black": "Svart skjøldur",
  "item.minecraft.shield.blue": "Blátt skjøldur",
  "item.minecraft.shield.brown": "Brúnt skjøldur",
  "item.minecraft.shield.cyan": "Turkis skjøldur",
  "item.minecraft.shield.gray": "Grátt skjøldur",
  "item.minecraft.shield.green": "Grønt skjøldur",
  "item.minecraft.shield.light_blue": "Ljósa blátt skjøldur",
  "item.minecraft.shield.light_gray": "Ljósa grátt skjøldur",
  "item.minecraft.shield.lime": "Ljósagrønt skjøldur",
  "item.minecraft.shield.magenta": "Viólreytt skjøldur",
  "item.minecraft.shield.orange": "Appelsingult skjøldur",
  "item.minecraft.shield.pink": "Ljósa reytt skjøldur",
  "item.minecraft.shield.purple": "Lilla skjøldur",
  "item.minecraft.shield.red": "Reytt skjøldur",
  "item.minecraft.shield.white": "Hvítt skjøldur",
  "item.minecraft.shield.yellow": "Gult skjøldur",
  "item.minecraft.shulker_shell": "Shulkerskel",
  "item.minecraft.shulker_spawn_egg": "Framkallingaregg fyri shulker",
  "item.minecraft.sign": "Sign",
  "item.minecraft.silence_armor_trim_smithing_template": "Smiðjusnið",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Tøgn Brynjuprýði",
  "item.minecraft.silverfish_spawn_egg": "Framkallingaregg fyri silvurkykt",
  "item.minecraft.skeleton_horse_spawn_egg": "Framkallingaregg fyri beinagrindarross",
  "item.minecraft.skeleton_spawn_egg": "Framkallingaregg fyri beinagrind",
  "item.minecraft.skull_banner_pattern": "Flaggmynstur",
  "item.minecraft.skull_banner_pattern.desc": "Skøltamynstur",
  "item.minecraft.skull_banner_pattern.new": "Flaggmynstur av Skølti",
  "item.minecraft.skull_pottery_shard": "Pottabrot av skølti",
  "item.minecraft.skull_pottery_sherd": "Pottabrot av skølti",
  "item.minecraft.slime_ball": "Slímklumpur",
  "item.minecraft.slime_spawn_egg": "Framkallingaregg fyri slím",
  "item.minecraft.smithing_template": "Smiðjusnið",
  "item.minecraft.smithing_template.applies_to": "Galdandi fyri:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Legg stong ella krystall til",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Brynja",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Legg brynju til",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Stengur & krystallir",
  "item.minecraft.smithing_template.ingredients": "Tilfar:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Legg netherittstong til",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamantútgerð",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Legg diamantbrynju, vápn ella tól til",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherittstong",
  "item.minecraft.smithing_template.upgrade": "Betra: ",
  "item.minecraft.sniffer_spawn_egg": "Framkallingaregg fyri snoddara",
  "item.minecraft.snort_pottery_shard": "Pottabrot av snýsan",
  "item.minecraft.snort_pottery_sherd": "Pottabrot av snýsan",
  "item.minecraft.snout_armor_trim_smithing_template": "Smiðjuformur",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snúti Brynjuprýði",
  "item.minecraft.snow_golem_spawn_egg": "Framkallingaregg fyri kavamenni",
  "item.minecraft.snowball": "Kavablak",
  "item.minecraft.spectral_arrow": "Dreygsørvur",
  "item.minecraft.spider_eye": "Eiturkoppaeyga",
  "item.minecraft.spider_spawn_egg": "Framkallingaregg fyri eiturkopp",
  "item.minecraft.spire_armor_trim_smithing_template": "Smiðjuformur",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spír Brynjuprýði",
  "item.minecraft.splash_potion": "Dýggjudrykkur",
  "item.minecraft.splash_potion.effect.awkward": "Klombrutur dýggjudrykkur",
  "item.minecraft.splash_potion.effect.empty": "Óevniligur dýggjudrykkur",
  "item.minecraft.splash_potion.effect.fire_resistance": "Eldmótstøðudýggjudrykkur",
  "item.minecraft.splash_potion.effect.harming": "Skaðandi dýggjudrykkur",
  "item.minecraft.splash_potion.effect.healing": "Grøðandi dýggjudrykkur",
  "item.minecraft.splash_potion.effect.infested": "Plágandi dýggjudrykkur",
  "item.minecraft.splash_potion.effect.invisibility": "Ósjónleikadýggjudrykkur",
  "item.minecraft.splash_potion.effect.leaping": "Risalopsdýggjudrykkur",
  "item.minecraft.splash_potion.effect.levitation": "Sveimandi dýggjudrykkur",
  "item.minecraft.splash_potion.effect.luck": "Eydnudýggjudrykkur",
  "item.minecraft.splash_potion.effect.mundane": "Turrisligur dýggjudrykkur",
  "item.minecraft.splash_potion.effect.night_vision": "Náttarsjóndardýggjudrykkur",
  "item.minecraft.splash_potion.effect.oozing": "Seyrandi dýggjudrykkur",
  "item.minecraft.splash_potion.effect.poison": "Eitrandi dýggjudrykkur",
  "item.minecraft.splash_potion.effect.regeneration": "Lekjandi dýggjudrykkur",
  "item.minecraft.splash_potion.effect.slow_falling": "Fjaðrarfalsdýggjudrykkur",
  "item.minecraft.splash_potion.effect.slowness": "Seinleikadýggjudrykkur",
  "item.minecraft.splash_potion.effect.strength": "Styrkjandi dýggjudrykkur",
  "item.minecraft.splash_potion.effect.swiftness": "Kvikleikadýggjudrykkur",
  "item.minecraft.splash_potion.effect.thick": "Tjúkkur dýggjudrykkur",
  "item.minecraft.splash_potion.effect.turtle_master": "Skjaldbøkumeistaradýggjudrykkur",
  "item.minecraft.splash_potion.effect.water": "Dýggjuvatnfløska",
  "item.minecraft.splash_potion.effect.water_breathing": "Táknudýggjudrykkur",
  "item.minecraft.splash_potion.effect.weakness": "Veikleikadýggjudrykkur",
  "item.minecraft.splash_potion.effect.weaving": "Vevnadýggjudrykkur",
  "item.minecraft.splash_potion.effect.wind_charged": "Vindløðandy dýggjudrykkur",
  "item.minecraft.spruce_boat": "Grannbátur",
  "item.minecraft.spruce_chest_boat": "Grannbátur við kistu",
  "item.minecraft.spyglass": "Kikari",
  "item.minecraft.squid_spawn_egg": "Framkallingaregg fyri høgguslokk",
  "item.minecraft.stick": "Pinnur",
  "item.minecraft.stone_axe": "Steinøks",
  "item.minecraft.stone_hoe": "Stein-lúkijarn",
  "item.minecraft.stone_pickaxe": "Steinhakkari",
  "item.minecraft.stone_shovel": "Steinspaki",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "Steinsvørð",
  "item.minecraft.stray_spawn_egg": "Framkallingaregg fyri villugrind",
  "item.minecraft.strider_spawn_egg": "Framkallingaregg fyri gleivara",
  "item.minecraft.string": "Tráður",
  "item.minecraft.sugar": "Sukur",
  "item.minecraft.suspicious_stew": "Illgrunasamur grýturættur",
  "item.minecraft.sweet_berries": "Søtber",
  "item.minecraft.tadpole_bucket": "Spann við sporlapaddum",
  "item.minecraft.tadpole_spawn_egg": "Framkallingaregg fyri sporlapaddu",
  "item.minecraft.tide_armor_trim_smithing_template": "Smiðjuformur",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Streymur Brynjuprýði",
  "item.minecraft.tipped_arrow": "Dyppaður ørvur",
  "item.minecraft.tipped_arrow.effect.awkward": "Dyppaður ørvur",
  "item.minecraft.tipped_arrow.effect.empty": "Óevniligur dyppaður ørvur",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Eldmótstøðuørvur",
  "item.minecraft.tipped_arrow.effect.harming": "Skaðandi ørvur",
  "item.minecraft.tipped_arrow.effect.healing": "Grøðandi ørvur",
  "item.minecraft.tipped_arrow.effect.infested": "Plágandi ørvur",
  "item.minecraft.tipped_arrow.effect.invisibility": "Ósjónleikaørvur",
  "item.minecraft.tipped_arrow.effect.leaping": "Risalopsørvur",
  "item.minecraft.tipped_arrow.effect.levitation": "Sveimiørvur",
  "item.minecraft.tipped_arrow.effect.luck": "Eydnuørvur",
  "item.minecraft.tipped_arrow.effect.mundane": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.night_vision": "Náttarsjóndarørvur",
  "item.minecraft.tipped_arrow.effect.oozing": "Seyruørvur",
  "item.minecraft.tipped_arrow.effect.poison": "Eitrandi ørvur",
  "item.minecraft.tipped_arrow.effect.regeneration": "Lekjandi ørvur",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Fjaðrarfalsørvur",
  "item.minecraft.tipped_arrow.effect.slowness": "Seinleikaørvur",
  "item.minecraft.tipped_arrow.effect.strength": "Styrkjandi ørvur",
  "item.minecraft.tipped_arrow.effect.swiftness": "Kvikleikaørvur",
  "item.minecraft.tipped_arrow.effect.thick": "Dyppaður ørvur",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Skjaldbøkurmeistaraørvur",
  "item.minecraft.tipped_arrow.effect.water": "Dýggjandi ørvur",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Táknuørvur",
  "item.minecraft.tipped_arrow.effect.weakness": "Veikleikaørvur",
  "item.minecraft.tipped_arrow.effect.weaving": "Vevnaørvur",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Vindløðingarørvur",
  "item.minecraft.tnt_minecart": "Námsvognur við TNT",
  "item.minecraft.torchflower_seeds": "Kyndilsblómufræ",
  "item.minecraft.totem_of_undying": "Ódeyðleikans totem",
  "item.minecraft.trader_llama_spawn_egg": "Framkallingaregg fyri handilslama",
  "item.minecraft.trial_key": "Próvlykil",
  "item.minecraft.trident": "Trítindur",
  "item.minecraft.tropical_fish": "Hitalandafiskur",
  "item.minecraft.tropical_fish_bucket": "Spann við tropiskum fiski",
  "item.minecraft.tropical_fish_spawn_egg": "Framkallingaregg fyri hitalandafisk",
  "item.minecraft.turtle_helmet": "Skjaldbøkuskel",
  "item.minecraft.turtle_scute": "Hornhylki frá skjaldbøku",
  "item.minecraft.turtle_spawn_egg": "Framkallingaregg fyri skjaldbøku",
  "item.minecraft.vex_armor_trim_smithing_template": "Smiðjusnið",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Argi Brynjuprýði",
  "item.minecraft.vex_spawn_egg": "Framkallingaregg fyri arga",
  "item.minecraft.villager_spawn_egg": "Framkallingaregg fyri bygdarfólk",
  "item.minecraft.vindicator_spawn_egg": "Framkallingaregg fyri hevndarfólk",
  "item.minecraft.wandering_trader_spawn_egg": "Framkallingaregg fyri ferðandi handilsfólk",
  "item.minecraft.ward_armor_trim_smithing_template": "Smiðjuformur",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Verji Brynjuprýði",
  "item.minecraft.warden_spawn_egg": "Framkallingaregg fyri vørð",
  "item.minecraft.warped_fungus_on_a_stick": "Tryglusoppur á pinni",
  "item.minecraft.water_bucket": "Spann við vatni",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smiðjuformur",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Vegvísari Brynjuprýði",
  "item.minecraft.wheat": "Hveiti",
  "item.minecraft.wheat_seeds": "Hveitifræ",
  "item.minecraft.white_bundle": "Hvítur pjøki",
  "item.minecraft.white_dye": "Hvítt litevni",
  "item.minecraft.white_harness": "White Harness",
  "item.minecraft.wild_armor_trim_smithing_template": "Smiðjuformur",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Vilt Brynjuprýði",
  "item.minecraft.wind_charge": "Vindløðing",
  "item.minecraft.witch_spawn_egg": "Framkallingaregg fyri heks",
  "item.minecraft.wither_skeleton_spawn_egg": "Framkallingaregg fyri withergrind",
  "item.minecraft.wither_spawn_egg": "Framkallingaregg fyri wither",
  "item.minecraft.wolf_armor": "Úlvabrynja",
  "item.minecraft.wolf_spawn_egg": "Framkallingaregg fyri úlv",
  "item.minecraft.wooden_axe": "Træøks",
  "item.minecraft.wooden_hoe": "Trælúkijarn",
  "item.minecraft.wooden_pickaxe": "Træhakkari",
  "item.minecraft.wooden_shovel": "Træspaki",
  "item.minecraft.wooden_spear": "Træspjót",
  "item.minecraft.wooden_sword": "Træsvørð",
  "item.minecraft.writable_book": "Bók og fjaðurpennur",
  "item.minecraft.written_book": "Skrivað bók",
  "item.minecraft.yellow_bundle": "Gulur pjøki",
  "item.minecraft.yellow_dye": "Gult litevni",
  "item.minecraft.yellow_harness": "Gul herklæðir",
  "item.minecraft.zoglin_spawn_egg": "Framkallingaregg fyri zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Framkallingaregg fyri deydningarross",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Framkallingaregg fyri deydning",
  "item.minecraft.zombie_villager_spawn_egg": "Framkallingaregg fyri deydningarbygdarfólk",
  "item.minecraft.zombified_piglin_spawn_egg": "Framkallingaregg fyri deydningarpiglin"
}
export const fo_fo = items; 
